<template>
  <form class="ortic-form-horizontal" ref="form">
    <o-card v-if="item" :capExceed="item.cap_exceeded ? true : false" :title="$t('sandoz.ice_peak_contract') + ' // ' + (item.contract_no ? item.contract_no : '-')" ref="card">
      <b-tabs class="inline-tabs" ref="tabs" v-model="activeTab">
        <b-tab :title="$t('sandoz.general')" active>

          <b-row>
            <b-col>
              <o-value-select v-model="item.user_id" :label="$t('sandoz.owner')"
                              :readonly="readonly" text-field="name"
                              url="/api/system/users?filter%5Bactive%5D=1%25&sortBy=name&include=flm,approval_roles,regions"
                              value-field="id" @input-object="setCurrentUser"></o-value-select>

              <b-alert show variant="warning" v-if="currentUser && item.region_id === null">{{$t('sandoz.no_region_user')}}</b-alert>
              <o-value-select v-model="item.type" :items="filteredContractTypes" :label="$t('sandoz.type')"
                              :readonly="readonly || !!item.id"/>

              <o-form-group :label="$t('sandoz.customer_external_id')" class="mb-2">
                <b-input-group>
                  <input v-model="item.customer_external_id" class="form-control" disabled type="text">
                  <b-input-group-append v-if="!readonly">
                    <b-btn variant="primary" @click.prevent="setMasterAddress">
                      <fa icon="ellipsis-h"/>
                    </b-btn>
                  </b-input-group-append>
                </b-input-group>
              </o-form-group>

              <o-input :label="$t('sandoz.' + buyingGroupLabel)" v-model="item.customer_group" class="pt-2 d-none" :class="{'d-flex': !sortalysContract}" :readonly="true"/>

              <o-form-group v-if="!sortalysContract && (buyingGroupKukos.length || buyingGroupContracts.length)" label="" class="mb-2 buying-group-links">
                <a v-if="buyingGroupKukos.length" href="#" class="small font-weight-bold mr-3" @click.prevent="openBuyingGroupLinks('kuko')">
                  <fa icon="link" class="mr-1"/>{{ $t('sandoz.buying_group_kuko') }}
                </a>
                <a v-if="buyingGroupContracts.length" href="#" class="small font-weight-bold" @click.prevent="openBuyingGroupLinks('contract')">
                  <fa icon="link" class="mr-1"/>{{ $t('sandoz.buying_group_contract') }}
                </a>
              </o-form-group>

              <o-value-select v-model="item.contract_year" :items="years" :label="$t('sandoz.contract_year')"
                              :readonly="readonly" :title="$t('sandoz.contract_year')"/>
              <o-datepicker ref="contract_start" :typeable="true" :errorField="'contract_start'"
                            :label="$t('sandoz.contract_start')" v-model="item.contract_start" :disabled="readonly"/>
              <o-datepicker :typeable="true" :errorField="'contract_expiration'"
                            :label="$t('sandoz.contract_expiration')" v-model="item.contract_expiration"
                            :disabledDates="disableToDates" :disabled="readonly"/>
              <o-form-group :label="$t('sandoz.new_customer')" class="new_customer_radio">
                <div class="w-100 pl-4 d-flex">
                  <b-form-radio v-model="item.new_customer" name="new_customer" :disabled="readonly" value="x">{{$t('sandoz.yes')}}</b-form-radio>
                  <b-form-radio v-model="item.new_customer" name="new_customer" :disabled="readonly" :value="null">{{$t('sandoz.no')}}</b-form-radio>
                </div>
              </o-form-group>

              <o-checkbox v-model="item.zero_invest" v-if="item.type == 'SD'" :label="$t('sandoz.zero_invest')" :readonly="readonly" ></o-checkbox>

              <o-form-group :label="$t('sandoz.previous_contract')" class="mb-2"
                            v-if="item.new_customer === null || (this.changeExternalID && item.new_customer === null)"
                            :errorField="'previous_contract'" :class="item.new_customer === null && (item.previous_contract === undefined || item.previous_contract === null || item.previous_contract === '') ? 'has-error' : ''" >
                  <b-input-group>
                      <input :value="item.previous && item.previous.contract_no ? item.previous.contract_no : null"
                              type="text" class="form-control"  disabled>
                      <b-input-group-append>
                          <b-btn variant="primary" @click.prevent="$refs.addPreviousContractModel.show()">
                            <fa icon="ellipsis-h"/>
                          </b-btn>
                      </b-input-group-append>
                      <input v-model="item.previous_contract" type="hidden">
                  </b-input-group>
              </o-form-group>

              <o-value-select :items="languages" :label="$t('sandoz.language')" v-model="item.language" :readonly="readonly || !!item.id"/>
              <div class="form-group" v-show="!readonly || (readonly && item.wholesaler_1_id)">
                <label>{{ $t('sandoz.wholesaler_1') }}</label>
                <select ref="wholesalerSelect" class="custom-select"
                  :disabled="readonly" v-model="item.wholesaler_1_id">
                  <option v-for="wholesaler1 in wholesalerArray" :value="wholesaler1.value" :key="wholesaler1.value">{{wholesaler1.text}}</option>
                </select>
              </div>

              <div class="form-group" v-show="(item.wholesaler_1_id && !readonly) || (readonly && item.wholesaler_2_id)">
                <label>{{ $t('sandoz.wholesaler_2') }}</label>
                <select class="custom-select"
                  :disabled="readonly" v-model="item.wholesaler_2_id">
                  <option v-for="wholesaler2 in wholesalerArray" :value="wholesaler2.value" :key="wholesaler2.value">{{wholesaler2.text}}</option>
                </select>
              </div>

              <div class="form-group" v-show="(item.wholesaler_2_id && !readonly) || (readonly && item.wholesaler_3_id)">
                <label>{{ $t('sandoz.wholesaler_3') }}</label>
                <select class="custom-select"
                  :disabled="readonly" v-model="item.wholesaler_3_id">
                  <option v-for="wholesaler3 in wholesalerArray" :value="wholesaler3.value" :key="wholesaler3.value">{{wholesaler3.text}}</option>
                </select>
              </div>

              <div class="form-group" v-show="(item.wholesaler_3_id && !readonly) || (readonly && item.wholesaler_4_id)">
                <label>{{ $t('sandoz.wholesaler_4') }}</label>
                <select class="custom-select"
                  :disabled="readonly" v-model="item.wholesaler_4_id">
                  <option v-for="wholesaler4 in wholesalerArray" :value="wholesaler4.value" :key="wholesaler4.value">{{wholesaler4.text}}</option>
                </select>
              </div>

              <div class="form-group" v-show="(item.wholesaler_4_id && !readonly) || (readonly && item.wholesaler_5_id)">
                <label>{{ $t('sandoz.wholesaler_5') }}</label>
                <select class="custom-select"
                  :disabled="readonly" v-model="item.wholesaler_5_id">
                  <option v-for="wholesaler5 in wholesalerArray" :value="wholesaler5.value" :key="wholesaler5.value">{{wholesaler5.text}}</option>
                </select>
              </div>
            </b-col>
            <b-col>

              <div class="position-absolute invest-accordion cursor-pointer mb-2">
                <fa icon="plus" @click="investAccordion = true"
                    v-if="!investAccordion" v-b-toggle.invest-collpase />
                <fa icon="minus" @click="investAccordion = false"
                    v-if="investAccordion" v-b-toggle.invest-collpase />
              </div>
              <label class="ml-4" v-b-toggle.invest-collpase @click="!investAccordion ? investAccordion = true : investAccordion = false"> {{ $t('sandoz.invest') }}</label>
              <b-collapse id="invest-collpase" class="mt-2">
                <o-input :group-class="sortalysContract ? 'd-none': 'd-flex'" :errorField="'turnover'" :label="$t('sandoz.turnover_year', {year: item.contract_year - 1})" v-model="item.turnover" format="number" :description="formatDescription(this.getPlanDataTurnoverActual())" :show-info="true" :show-info-descirption="$t('sandoz.turnover_info', { year: item.contract_year - 1 })"/>
                <!-- :description="formatDescription(item.plan_turnover_actual)" :descriptionClass="calculatePlanTurnOver()" -->
                <!-- <span>{{ item.plan_turnover_actual | formatInteger }}</span> -->
                <o-input :group-class="[sortalysContract ? 'd-none': 'd-flex', (compareTurnoverExpectationForOTC() ? 'has-error' : '')]" :errorField="'turnover_expectation'" :readonly="readonly"
                        :label="$t('sandoz.turnover_expectation_year', {year: item.contract_year})"
                        v-model="item.turnover_expectation" :append="turnoverExpectionPercentage" format="number" :description="formatDescription(item.plan_turnover_expectation)" :descriptionClass="calculatePlanTurnOverExpectation()"  :rightdescription="turnoverExpectionPercentageBaseline" :rightdescriptionClass="calculatePlanTurnOver()"/>
                <hr class="vertical-hr" v-if="!sortalysContract">
                <o-form-group :label="apoOtcContract ? sortalysQuantity > 0 ? $t('sandoz.total_marketing_activities_otc_sortalys') + '('+sortalysQuantity+')' : $t('sandoz.total_marketing_activities_otc_sortalys') : $t('sandoz.total_marketing_activities')">
                  <b-row class="w-100">
                    <b-col>
                      <o-input-control :errorField="'marketing_activities_maximum'" v-model="item.marketing_activities_maximum" format="number" :description="!apoOtcContract ? formatDescription(item.plan_target_invest) : ''" :descriptionClass="calculatePlanTargetInvest()" :readonly="(sortalysContract || apoOtcContract) || readonly"/>
                    </b-col>
                    <b-col>
                      <div class="input-group" :class="sortalysContract ? 'd-none': 'd-flex'">
                        <o-input-percentage-control :errorField="'marketing_activities_percentage'" v-model="item.marketing_activities_percentage" type="number" :min="0.01" :max="99.99" :only-integer="false" append="%" :readonly="apoOtcContract || readonly"/>
                        <div class="input-group-append">
                          <span class="input-group-text">%</span>
                        </div>
                      </div>
                      
                    </b-col>
                  </b-row>
                </o-form-group>
                <template v-if="apoOtcContract">
                  <div class="form-group">
                    <label :class="(compareMarketingActivityForOTC() ? 'has-error' : '')">{{$t('sandoz.total_marketing_activities_otc')}}</label>
                    <b-row class="w-100">
                      <b-col>
                        <o-input-control :class="(compareMarketingActivityForOTC() ? 'has-error' : '')" :errorField="'marketing_activities_otc'" v-model="item.marketing_activities_otc" format="number" :description="formatDescription(item.plan_target_invest)" :readonly="readonly"/>
                      </b-col>

                      <b-col>
                        <div class="input-group">
                          <o-input-percentage-control :errorField="'marketing_activities_otc_percentage'" v-model="item.marketing_activities_otc_percentage" type="number" :min="0.01" :max="99.99" :only-integer="false" append="%" :readonly="apoOtcContract || readonly"/>
                          <div class="input-group-append">
                            <span class="input-group-text">%</span>
                          </div>
                        </div>
                        <small v-if="marketing_activities_percentage !== null " class="form-text text-muted">{{ marketing_activities_percentage | formatPricePercentage }}%</small>
                        </b-col>
                    </b-row>
                  </div>
                </template>

                <hr v-if="!sortalysContract">

                <o-input :group-class="sortalysContract ? 'd-none': 'd-flex'" :errorField="'growth_forecast'" :label="$t('sandoz.growth_forecast')"
                        v-model="item.growth_forecast" format="number" :readonly="true"/>

                <div class="d-none" :class="{'d-block': user && user.is_super_user && !sortalysContract}">
                  <o-input :errorField="'invest_turnover'" :label="$t('sandoz.cal_invest_turnover', {year: item.contract_year -1})"
                          v-model="item.invest_turnover" type="number" format="number" :readonly="true" :append="investTurnoverPercentage"/>
                  <input v-model="item.invest_turnover_percentage" type="hidden"/>

                  <o-input :errorField="'invest_turnover_forecast'" :label="$t('sandoz.cal_invest_turnover_forecast', {year: item.contract_year})"
                          v-model="item.invest_turnover_forecast" type="number" :readonly="true" :append="investGrowthPercentage" format="number"/>
                  <input v-model="item.invest_growth" type="hidden"/>

                  <o-input :errorField="'invest_max'" :label="$t('sandoz.cal_invest_max')"
                          v-model="item.invest_max" type="number" :readonly="true" :append="investMaxPercentage" format="number"/>
                  <input v-model="item.invest_max_percentage" type="hidden"/>
                </div>
                <!-- If we have multiple KUKOs, show the sum of discount and the KUKO ID table -->
                <template v-if="item.kukos && item.kukos.length > 1">
                  <div class="form-group d-flex">
                    <label>{{ $t('sandoz.kuko_discount') }}</label>
                    <div class="w-100">
                      <input type="text" readonly="readonly" class="form-control" v-model="item.discount">
                      <small v-if="item.plan_target_discount" class="form-text" :class="calculatePlanTargetDiscount()">{{ item.plan_target_discount | formatInteger }}</small>
                    </div>
                  </div>

                  <div class="form-group d-flex">
                    <label>{{ $t('sandoz.kuko_id') }}</label>
                    <div class="w-100">
                      <div class="table-responsive mb-2">
                        <table class="table table-bordered table-sm table-hover mb-0 bg-white">
                          <thead class="thead-light">
                            <tr>
                              <th class="align-middle px-3 py-2 font-weight-bold">{{ $t('sandoz.kuko_id') }}</th>
                              <th class="align-middle px-3 py-2 font-weight-bold">{{ $t('sandoz.status') }}</th>
                              <th class="align-middle text-right px-3 py-2" style="width: 150px;">{{ $t('core.actions') }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="kuko in item.kukos" :key="kuko.id">
                              <td class="align-middle px-3 font-weight-bold">{{ kuko.id }}</td>
                              <td class="align-middle px-3">{{ kuko.status }}</td>
                              <td class="align-middle text-right px-3 py-1">
                                <button class="btn btn-sm btn-outline-secondary" type="button" @click="openKuko(kuko.id)">
                                  <fa icon="external-link-alt" class="mr-1"/>{{ $t('sandoz.open_kuko') }}
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </template>

                <!-- Otherwise (single KUKO or no KUKOs), show the legacy layout exactly -->
                <template v-else>
                  <div class="form-group d-flex">
                    <label>{{ $t('sandoz.kuko_discount') }}</label>
                    <div class="w-100">
                      <div role="group" class="input-group">
                        <input type="text" readonly="readonly" class="form-control" v-model="item.discount">
                        <div class="input-group-append">
                          <button class="btn btn-outline-secondary" v-if="item.kuko_link" type="button" @click="openKuko(item.kuko_link)">{{ $t('sandoz.open_kuko') }}</button>
                          <template v-else-if="!readonly && user && hasPermission(['POST api/kukos/{id}'])">
                            <button class="btn btn-outline-secondary" type="button" @click="createKuko">{{ $t('sandoz.create_kuko') }}</button>
                            <button class="btn btn-outline-secondary" type="button" @click="openCopyPreviousYearKuko">{{ $t('sandoz.copy_previous_year_kuko') }}</button>
                          </template>
                        </div>
                      </div>
                      <small v-if="item.plan_target_discount" class="form-text" :class="calculatePlanTargetDiscount()">{{ item.plan_target_discount | formatInteger }}</small>
                      <small v-if="item.kuko_link" class="form-text text-muted">{{ $t('sandoz.kuko_id') }}: {{ item.kuko_link }}</small>
                    </div>
                  </div>
                </template>

                <hr v-if="!sortalysContract">

                <b-form-checkbox v-model="item.plan_deviation_skip_approval" value="true" v-if="checkPlanDeviationSkipApproval" :disabled="readonly">{{$t('sandoz.plan_deviation_skip_approval_info')}}</b-form-checkbox>
                <o-form-group :label="$t('sandoz.circulation')" class="mt-3"
                              v-if="sortalysContract || ((displayBusinessCase() && item.marketing_activities_maximum > 0 && item.marketing_activities_percentage > 0) || (item.turnover > 0 && item.turnover_expectation > 0 && item.marketing_activities_maximum > 0 && item.marketing_activities_percentage > 0))">
                  <table class="table table-sm">
                    <template v-for="i in [1,2,3,4,5,6]">
                      <tr :key="i" v-if="item['approver_' + i]">
                        <td>{{item['approver_' + i]}}</td>
                        <td>
                          <span v-if="item['approval_person_' + i]" :title="item['approval_date_' + i]">
                            <fa icon="check"/> {{item['approval_person_' + i]}}
                          </span>
                          <span v-else>
                            -
                          </span>
                        </td>
                      </tr>
                    </template>
                  </table>
                </o-form-group>
                <hr>
                <o-input :errorField="'reason_businesscase'" :class="showBusinessCase() && (item.reason_businesscase === '' || item.reason_businesscase === null) ? 'has-error' : ''" :label="$t('sandoz.reason_businesscase', {year: item.contract_year})"
                v-model="item.reason_businesscase" v-if="showBusinessCase()" :readonly="readonly"/>
              </b-collapse>

              <o-textarea v-model="item.sales_rep_comment" :label="$t('sandoz.sales_rep_comment')" class="mt-3"></o-textarea>

              <template v-if="user.is_super_user">
                <o-textarea v-model="item.super_user_comment" :label="$t('sandoz.super_user_comment')" class="mt-3"
                            :error-field="'super_user_comment'"
                            :class="isCommentError && !item.super_user_comment ? 'has-error' : ''"></o-textarea>
              </template>
            </b-col>
          </b-row>

          <b-btn @click.prevent="activeTab++">{{$t('sandoz.next')}}</b-btn>
        </b-tab>

        <b-tab :title="$t('sandoz.addresses')">
          <b-overlay :show="item.customer_external_id == null">

            <div class="d-flex">
              <b-btn @click="addAddress">{{ $t('sandoz.add_address') }}</b-btn>
            </div>

            <div class="table-responsive">
              <table class="table">
                <thead>
                <tr>
                  <th>{{ $t('sandoz.hco') }}</th>
                  <th>{{ $t('sandoz.address') }}</th>
                  <th>{{ $t('sandoz.zip') }}</th>
                  <th>{{ $t('sandoz.city') }}</th>
                  <th>{{ $t('sandoz.customer_external_id') }}</th>
                  <th v-if="item.type === 'SD' || item.type === 'IMMUNO' || item.type === 'CNS' || item.type === 'ONCO'">{{ $t('sandoz.fte') }}</th>
                  <th v-if="item.type === 'APO' || item.type === 'BIOS_APO' || item.type === 'HEIM' || item.type === 'APO_OTC' || item.type === 'APO_KUKO'">{{ $t('sandoz.classification') }}</th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(address, addressIndex) in item.addresses" :key="addressIndex"
                    :class="{'bg-light': address.address_type === 'master'}">
                  <td>
                    {{ address.company_name }}
                    <o-inline-edit v-if="address.address_type === 'master'" v-model="address.company_name"/>
                  </td>
                  <td>
                    {{ address.street }}
                    <o-inline-edit v-if="address.address_type === 'master'" v-model="address.street"/>
                  </td>
                  <td>
                    {{ address.zip }}
                    <o-inline-edit v-if="address.address_type === 'master'" v-model="address.zip"/>
                  </td>
                  <td>
                    {{ address.city }}
                    <o-inline-edit v-if="address.address_type === 'master'" v-model="address.city"/>
                  </td>
                  <td>{{ address.customer_external_id }}</td>
                  <td v-if="item.type === 'SD' || item.type === 'IMMUNO' || item.type === 'CNS' || item.type === 'ONCO'"
                      class="text-nowrap">
                    <b-input v-if="address.address_type !== 'master'" v-model.number="address.fte"
                             class="mw-very-small" step="0.05" type="number" :class="{'border-danger': !address.fte}"
                             @blur.native="addItemsToAddresses(false)"/>
                  </td>
                  <td v-if="item.type === 'APO' || item.type === 'BIOS_APO' || item.type === 'APO_OTC' || item.type === 'APO_KUKO'">
                    <b-form-select v-if="address.address_type !== 'master'" v-model="address.customer_size"
                                   :options="customerSizes[addressIndex]" :class="{'border-danger': !address.customer_size && item.type !== 'APO_KUKO'}"
                                   @change.native="addItemsToAddresses(false)"></b-form-select>
                  </td>
                  <td v-if="item.type === 'HEIM'">
                    <b-form-select v-if="address.address_type !== 'master'" v-model="address.customer_size"
                                   :options="heimCustomerSizes[addressIndex]" :class="{'border-danger': !address.customer_size}"
                                   @change.native="addItemsToAddresses(false)"></b-form-select>
                  </td>
                  <td class="text-right text-nowrap">
                    <div v-if="addressIndex > 0" aria-label="edit controls" class="btn-group btn-group-sm"
                        role="group">
                      <o-delete v-on:execute-action="item.addresses.splice(addressIndex, 1)"
                                text="Are you sure you want to remove this address?"></o-delete>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <template #overlay>
              <div class="text-center">
                <p>{{$t('sandoz.set_external_id_first')}}</p>
              </div>
            </template>
          </b-overlay>

          <b-btn @click.prevent="activeTab--">{{$t('sandoz.previous')}}</b-btn>
          <b-btn @click.prevent="activeTab++">{{$t('sandoz.next')}}</b-btn>
        </b-tab>
        <b-tab :title="$t('sandoz.items')" v-if="!hideItemsTab">
          <contract-item :item="item" :apoOtcContract="apoOtcContract" :sortalysQuantity=sortalysQuantity :sortalysPrice=sortalysPrice :activeTab="activeTab" :sortalysContract="sortalysContract" :user="user" :determErrorID="determErrorID" :reqBiosApoItems="reqBiosApoItems" :months="months" :readonly="readonly" :fromDateErrorID="fromDateErrorID" ref="contractItem"></contract-item>
          <b-btn @click.prevent="activeTab--">{{$t('sandoz.previous')}}</b-btn>
          <b-btn @click.prevent="activeTab++">{{$t('sandoz.next')}}</b-btn>
        </b-tab>
        <b-tab :title="$t('sandoz.events')" v-if="false">

          <div>
            {{ $t('sandoz.event_info') }}: <a href="https://sandoz-academy.ch/" target="_blank">https://sandoz-academy.ch</a>
          </div>
          <!-- <b-overlay :show="item.type == null">
            <template v-for="(address, index) in item.addresses">
              <template v-if="address.address_type === 'delivery'">
                <div class="d-flex">
                  <div class="pt-2">
                    <b>
                      {{ address.company_name ?  address.company_name + ', ' : '' }}
                      {{ address.street ? address.street + ', ' : '' }}
                      {{ address.zip }} {{ address.city }}
                    </b>
                    <b-badge v-if="address.cap_exceeded" pill href="#"  class="ml-2" variant="danger">{{$t('sandoz.cap_exceeded')}}</b-badge>
                  </div>
                  <div class="ml-auto">
                    <div v-if="!address.fte && !address.customer_size" class="badge badge-danger">{{$t('sandoz.unclassified_address')}}</div>
                  </div>
                </div>
                <div class="table-responsive mt-3 ml-2 ice-item-table-div" v-if="address.fte || address.customer_size">
                  <table class="table table-sm ice-item-table">
                    <thead>
                    <tr>
                      <th scope="col" class="mw-400">{{ $t('sandoz.item') }}</th>
                      <th scope="col">
                        <b-form-checkbox v-model="address.eventHeaderCheckbox" @change="updateEventCheckboxes(address, index)">{{ $t('sandoz.inform') }}</b-form-checkbox>
                      </th>
                    </tr>
                    </thead>
                    <tbody v-if="address.items && Object.keys(address.items).length">
                    <template v-for="(line, lineIndex) in address.items">
                      <tr class="master-item" v-if="line.type === 'service' && line.sandoz_academy_event">
                        <td>
                          <div class="position-absolute item-accordion cursor-pointer"
                               v-if="checkLineChildren(line)">
                            <fa icon="plus" @click="toggleAccordion(index, lineIndex)"
                                v-if="getAccordion(index, lineIndex) !== -1"/>
                            <fa icon="minus" @click="toggleAccordion(index, lineIndex)"
                                v-if="getAccordion(index, lineIndex) === -1"/>
                          </div>
                          <div v-if="!line.allow_product_name_to_change"> {{ line.product ? line.product.name : line.product_name }}</div>
                          <div v-else> <o-input-control type="text" v-model="line.product_name" class="full-width"> </o-input-control></div>
                        </td>
                        <td>
                          <template v-if="isReadonly(line, 'yearly')">
                            <b-form-checkbox value="1" :disabled="true" v-model="line.delivery.yearly.quantity" @change="setPrice(line, index, 'yearly'), setQuantityToChild(line, 'q1', index)"  v-if="line.delivery.yearly"></b-form-checkbox>
                          </template>
                          <template v-else>
                            <b-form-checkbox value="1" v-model="line.delivery.yearly.quantity" @change="setPrice(line, index, 'yearly'), setQuantityToChild(line, 'q1', index)"></b-form-checkbox>
                          </template>
                        </td>
                      </tr>
                      <template v-if="line.children && Object.keys(line.children).length">
                        <template v-for="(subLine, subLineIndex) in line.children">
                          <tr v-if="line.type === 'service' && line.sandoz_academy_event && subLine.type === 'service' && subLine.sandoz_academy_event"
                              :class="{'d-none': (!!subLine.hide_in_contract || getAccordion(index, lineIndex) !== -1)}">
                            <td class="indention" v-if="!subLine.allow_product_name_to_change">{{ subLine.product ? subLine.product.name : subLine.product_name }}</td>
                            <td class="indention" v-else>
                              <o-input-control type="text" v-model="subLine.product_name" class="full-width"> </o-input-control>
                            </td>
                            <td>
                              <template v-if="isReadonly(subLine, 'yearly')">
                                <b-form-checkbox value="1" :disabled="true" v-model="subLine.delivery.yearly.quantity" v-if="subLine.delivery.yearly"></b-form-checkbox>
                              </template>
                              <template v-else>
                                <b-form-checkbox value="1" v-model="subLine.delivery.yearly.quantity" @change="setQuantityToParent(line, subLine, 'yearly', index),
                                  setQuantityToChild(subLine, 'yearly', subLineIndex),
                                  setBoxQuantity(line, 'yearly', subLine.box_or_gadget, index)">
                                </b-form-checkbox>
                              </template>
                            </td>
                          </tr>
                          <template v-if="subLine.children && Object.keys(subLine.children).length">
                            <template v-for="(childLine, childLineIndex) in subLine.children">
                              <tr v-if="subLine.type === 'service' && subLine.sandoz_academy_event && childLine.type === 'service' && childLine.sandoz_academy_event"
                                  :class="{'d-none': !!childLine.hide_in_contract || getAccordion(index, lineIndex) !== -1}">
                                <td class="indention-1" v-if="!childLine.allow_product_name_to_change">{{ childLine.product ? childLine.product.name : childLine.product_name }}</td>
                                <td class="indention-1" v-else>
                                  <o-input-control type="text" v-model="childLine.product_name" class="full-width"> </o-input-control>
                                </td>
                                <td>
                                  <template v-if="isReadonly(childLine, 'yearly')">
                                    <b-form-checkbox value="1" :disabled="true" v-model="childLine.delivery.yearly.quantity" v-if="childLine.delivery.yearly"></b-form-checkbox>
                                  </template>
                                  <template v-else-if="childLine.delivery.yearly">
                                    <b-form-checkbox value="1" v-model="childLine.delivery.yearly.quantity" @change="setQuantityToParent(subLine, childLine, 'yearly', index),
                                      setBoxQuantity(line, 'yearly', childLine.box_or_gadget, index)">+
                                    </b-form-checkbox>
                                  </template>
                                </td>
                              </tr>
                            </template>
                          </template>
                        </template>
                      </template>
                    </template>
                    </tbody>
                    <tbody v-else>
                    <tr>
                      <td align="center" colspan="11">{{ $t('core.no_records') }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <div v-else-if="item.type == 'SD' && !address.fte">
                  <div class="text-center">
                    <p>{{$t('sandoz.set_fte_first')}}</p>
                  </div>
                </div>
                <div v-else-if="item.type == 'APO' && !address.customer_size">
                  <div class="text-center">
                    <p>{{$t('sandoz.set_customer_size_first')}}</p>
                  </div>
                </div>
              </template>
            </template>
            <template #overlay>
              <div class="text-center">
                <p>{{$t('sandoz.set_type_first')}}</p>
              </div>
            </template>
          </b-overlay> -->
          <b-btn @click.prevent="activeTab--">{{$t('sandoz.previous')}}</b-btn>
          <b-btn @click.prevent="activeTab++">{{$t('sandoz.next')}}</b-btn>
        </b-tab>

        <b-tab :title="$t('sandoz.contract')">
          <o-button native-type="button" @click="confirmWithUser" class="btn btn-danger" target="_blank" :loading="pdfLoading" :disabled="pdfLoading">Download PDF</o-button>
          <a :href="vendorFormLinks[item.language]" class="btn btn-primary ml-2" target="_blank">{{ $t('sandoz.vendor_form') }}</a>
          <template v-if="draftInvoiceAvailable">
            <template v-if="item.payment_schema === 'semester'">
              <a :href="draftInvoiceS1Url" class="btn btn-danger ml-2" target="_blank">
                {{ $t('sandoz.download_draft_invoice_s1') }}
              </a>
              <a :href="draftInvoiceS2Url" class="btn btn-danger ml-2" target="_blank">
                {{ $t('sandoz.download_draft_invoice_s2') }}
              </a>
            </template>
            <a :href="draftInvoiceYearUrl" class="btn btn-danger ml-2" target="_blank">
              {{ $t('sandoz.download_draft_invoice') }}
            </a>
          </template>
          <template-download-button v-if="$route.params.id !== 'new'" :contract-id="$route.params.id" class="ml-2"/>

          <b-row class="mt-4">
            <b-col xl="8" lg="12" md="12" >

              <o-value-select :items="paymentSchemas" :label="$t('sandoz.payment_schema')" v-model="item.payment_schema" :readonly="readonly"/>

              <template v-for="i in [1,2,3,4,5,6,7]">
                <o-form-group :key="i" :label="$t('sandoz.contract_partner_' + i)">
                  <b-container class="w-100 px-0">
                    <b-row>
                      <b-col class="pr-1">
                        <b-input-group :prepend="$t('sandoz.name')">
                          <b-form-input v-model="item['contract_partner_' + i]" :disabled="readonly"></b-form-input>
                        </b-input-group>
                      </b-col>
                      <b-col class="pl-1">
                        <b-input-group :prepend="$t('sandoz.title')">
                          <b-form-input v-model="item['contract_partner_' + i + '_title']" :disabled="readonly"></b-form-input>
                        </b-input-group>
                      </b-col>
                      <b-col class="pl-1">
                        <select class="custom-select" v-model="item['contract_partner_' + i + '_title_dropdown']" @change="setTitle(i)" :disabled="readonly">
                          <option v-for="titleItem in titleItems" :value="titleItem.value" :key="titleItem.value">{{titleItem.text}}</option>
                        </select>
                      </b-col>
                    </b-row>
                  </b-container>
                </o-form-group>
              </template>
            </b-col>
            <b-col xl="4"  lg="12" md="12">
              <o-form-group>
                <b-form-checkbox v-model.lazy="item.vat" name="vat" value="x" :disabled="readonly">
                  {{ $t('sandoz.vat_obligation') }}
                </b-form-checkbox>
              </o-form-group>

              <o-input v-if="item.vat == 'x'" v-model="item.vat_number" :errorField="'vat_number'"
                       :label="$t('sandoz.vat_number')" :readonly="readonly"/>
              <o-input v-model="item.bank_name" :errorField="'bank_name'" :label="$t('sandoz.bank_name')" :readonly="readonly"/>
              <o-input v-model="item.bank_address" :errorField="'bank_address'" :label="$t('sandoz.bank_address')" :readonly="readonly"/>
              <o-input v-model="item.accountholder_name" :errorField="'accountholder_name'"
                       :label="$t('sandoz.accountholder_name')" :readonly="readonly"/>
              <o-input v-model="item.accountholder_address" :errorField="'accountholder_address'"
                       :label="$t('sandoz.accountholder_address')" :readonly="readonly"/>
              <o-input v-model="item.iban_no" :errorField="'iban_no'" :label="$t('sandoz.iban_no')" :readonly="readonly"/>

            </b-col>
          </b-row>
          <b-btn @click.prevent="activeTab--">{{$t('sandoz.previous')}}</b-btn>
          <b-btn @click.prevent="activeTab++">{{$t('sandoz.next')}}</b-btn>
        </b-tab>
        <b-tab :title="$t('sandoz.files')">
          <contract-file :item="item" :user="user"></contract-file>
          <b-btn @click.prevent="activeTab--">{{$t('sandoz.previous')}}</b-btn>
        </b-tab>
      </b-tabs>
      <address-search ref="addressSearch" :address-mode-checkbox="showAddressModeCheckbox" contract-type="icepeak" @address-selected="addressSelected"></address-search>
    </o-card>
    <o-action-toolbar>
      <div class="d-flex w-100">
        <o-button type="button" variant="outline-primary" @click.prevent="back">{{ $t('core.back') }}</o-button>
        <div class="ml-auto">
          <span class="badge badge-danger mr-3" v-if="duplicateContract">{{ $t('sandoz.duplicate_ice_approval') }}</span>
          <span class="badge badge-danger mr-3" v-if="kukoErrorMessage">{{ kukoErrorMessage }}</span>
          <o-data-history v-if="item && item.id" class="mr-2" type="App\Models\Sandoz\Contract" :id="item.id"></o-data-history>
          <o-button v-if="(user && user.is_super_user) && (item && (item.status == 'Committed' || item.status == 'Approved' || item.status == 'Signed') && item.contract_year > 2023)"
                    :loading="saving" type="button" variant="primary"
                    @click.prevent="$refs.resetContractModel.show()">{{ $t('sandoz.reset_to_draft') }}
          </o-button>
          <template v-if="!$route.path.split('/').includes('view')">
            <template v-if="saveDisabled">
              <o-button v-if="(item && (item.status == 'Draft' || item.status == 'Feedback'))" :loading="saving" type="button" variant="danger">{{ $t('sandoz.budget_used_up') }}
              </o-button>
            </template>
            <template v-else>
              <o-button v-if="(item && (item.status == 'Draft' || item.status == 'Feedback'))" :loading="saving" type="button" variant="primary"
                      @click.prevent="contractCanApprovable" :disabled="duplicateContract || !!kukoErrorMessage">{{ $t('sandoz.upload_start_approval') }}
              </o-button>
              <o-button v-if="(item && (item.status == 'Draft'))" :loading="saving" type="button" variant="primary"
                        @click.prevent="save">{{ $t('sandoz.save_draft') }}
              </o-button>
              <o-button v-if="(item && (item.status == 'Feedback'))" :loading="saving" type="button" variant="primary"
                        @click.prevent="save">{{ $t('core.save') }}
              </o-button>
            </template>
          </template>
        </div>
      </div>
    </o-action-toolbar>
    <b-modal id="modal-previous-contract" ref="addPreviousContractModel" :title="$t('sandoz.select_previous_contract')"
                     :ok-only="true" size="xl" :ok-title="$t('core.cancel')">
        <o-table url="/api/sandoz/contracts?include=master_address_single" title="" ref="previousContractList" :enable-new="false"
                  :enable-delete="false" :enable-edit="false" :shadow="false" :only-filterable="true">
            <template slot="filter">
                <o-filter v-on:filter-updated="(filters) => $refs.previousContractList.setFilters(filters)">
                    <o-filter-text :title="$t('sandoz.contract_no')" column="contract_no"></o-filter-text>
                    <o-filter-text :title="$t('sandoz.customer_external_id')" column="customer_external_id"></o-filter-text>
                    <o-filter-select :items="years" :title="$t('sandoz.contract_year')" column="contract_year"></o-filter-select>
                </o-filter>
            </template>
            <template slot="head">
                <o-table-header column="contract_no">{{$t('sandoz.contract_no')}}</o-table-header>
                <o-table-header column="customer_external_id">{{$t('sandoz.customer_external_id')}}</o-table-header>
                <o-table-header column="contract_year">{{$t('sandoz.contract_year')}}</o-table-header>
                <o-table-header :sortable="false">{{$t('sandoz.name')}}</o-table-header>
                <o-table-header :sortable="false">{{$t('sandoz.last_name')}}</o-table-header>
                <o-table-header :sortable="false">{{$t('sandoz.company_name')}}</o-table-header>
                <o-table-header :sortable="false">{{$t('sandoz.street')}}</o-table-header>
                <o-table-header :sortable="false">{{$t('sandoz.zip')}}</o-table-header>
                <o-table-header :sortable="false">{{$t('sandoz.city')}}</o-table-header>
            </template>
            <template slot="body" slot-scope="previousContractProps">
                <td>{{ previousContractProps.item.contract_no }}</td>
                <td>{{ previousContractProps.item.customer_external_id }}</td>
                <td>{{ previousContractProps.item.contract_year }}</td>
                <td>{{ previousContractProps.item.master_address_single && previousContractProps.item.master_address_single.data ?
                    previousContractProps.item.master_address_single.data.name : ''}}
                </td>
                <td>{{ previousContractProps.item.master_address_single && previousContractProps.item.master_address_single.data ?
                    previousContractProps.item.master_address_single.data.last_name : ''}}
                </td>
                <td>{{ previousContractProps.item.master_address_single && previousContractProps.item.master_address_single.data ?
                    previousContractProps.item.master_address_single.data.company_name : ''}}
                </td>
                <td>{{ previousContractProps.item.master_address_single && previousContractProps.item.master_address_single.data ?
                    previousContractProps.item.master_address_single.data.street : ''}}
                </td>
                <td>{{ previousContractProps.item.master_address_single && previousContractProps.item.master_address_single.data ?
                    previousContractProps.item.master_address_single.data.zip : ''}}
                </td>
                <td>{{ previousContractProps.item.master_address_single && previousContractProps.item.master_address_single.data ?
                    previousContractProps.item.master_address_single.data.city : ''}}
                </td>
            </template>
            <template slot="body-controls" slot-scope="previousContractProps">
                <td class="text-right">
                    <div v-if="previousContractProps.item.id === item.id">
                        <span class="badge badge-success">Current </span>
                    </div>
                    <div v-else-if="previousContractProps.item.id === item.previous_contract">
                        <span class="badge badge-warning">Previous</span>
                    </div>
                    <div v-else class="btn-group btn-group-sm" role="group" aria-label="edit controls">
                        <b-btn variant="primary" @click="addPreviousContract(previousContractProps.item)">
                            <fa icon="arrow-right"/>
                        </b-btn>
                    </div>
                </td>
            </template>
        </o-table>
    </b-modal>
    <b-modal id="modal-reset-contract" ref="resetContractModel" :title="$t('sandoz.reset_to_draft')">
      {{$t('sandoz.reset_confirmation')}}
      <template #modal-footer="{ ok, cancel, hide }">
        <b-button variant="secondary" @click="cancel()">
          {{$t('core.cancel')}}
        </b-button>
        <b-button variant="primary" @click="resetToDraft()">
          {{$t('core.ok')}}
        </b-button>
      </template>
    </b-modal>
    <b-modal id="modal-duplicate-contract" ref="duplicateContractModel" :title="$t('sandoz.duplicate_contract')">
      {{$t('sandoz.duplicate_contract_error')}}
      <template #modal-footer="{ ok, cancel, hide }">
        <b-button variant="secondary" @click="showDuplicateContract">
          {{$t('sandoz.show_contract')}}
        </b-button>
        <b-button variant="primary" @click="cancel()">
          {{$t('core.ok')}}
        </b-button>
      </template>
    </b-modal>
    <b-modal id="modal-past-contract" ref="pastContractModel" :title="$t('sandoz.past_contract')">
      {{$t('sandoz.past_contract_warning')}}
      <template #modal-footer="{ ok, cancel, hide }">
        <b-button variant="secondary" @click="cancel()">
          {{$t('core.cancel')}}
        </b-button>
        <b-button variant="primary" @click="saveAndStartApproval()">
          {{ $t('sandoz.upload_start_approval') }}
        </b-button>
      </template>
    </b-modal>

    <!-- Clone comparison modal -->
    <contract-clone-comparison
      ref="cloneComparison"
      :source-contract="cloneSourceContract"
      :available-product-master-ids="cloneAvailableMasterIds"
      :target-year="cloneTargetYear"
      @confirm="onCloneConfirm"
    />

    <b-modal id="modal-kuko-save-warning" ref="kukoSaveWarningModel" :title="$t('sandoz.create_kuko')">
      {{$t('sandoz.kuko_save_required_message')}}
      <template #modal-footer="{ ok, cancel, hide }">
        <b-button variant="secondary" @click="cancel()">
          {{$t('core.cancel')}}
        </b-button>
        <b-button variant="primary" @click="saveAndContinueKuko()">
          {{$t('sandoz.save_and_continue')}}
        </b-button>
      </template>
    </b-modal>
    <b-modal id="modal-buying-group-links" ref="buyingGroupLinksModal" :ok-only="true" size="lg" :ok-title="$t('core.cancel')"
             :title="buyingGroupLinkType === 'kuko' ? $t('sandoz.select_buying_group_kuko') : $t('sandoz.select_buying_group_contract')">
      <table class="table table-sm table-hover mb-0">
        <thead>
          <tr v-if="buyingGroupLinkType === 'kuko'">
            <th>{{$t('sandoz.kuko_id')}}</th>
            <th>{{$t('sandoz.customer_external_id')}}</th>
            <th>{{$t('sandoz.type')}}</th>
            <th>{{$t('sandoz.contract_year')}}</th>
            <th>{{$t('sandoz.status')}}</th>
            <th></th>
          </tr>
          <tr v-else>
            <th>{{$t('sandoz.contract_no')}}</th>
            <th>{{$t('sandoz.type')}}</th>
            <th>{{$t('sandoz.contract_year')}}</th>
            <th>{{$t('sandoz.status')}}</th>
            <th></th>
          </tr>
        </thead>
        <tbody v-if="buyingGroupLinkType === 'kuko'">
          <tr v-for="kuko in buyingGroupKukos" :key="'bg-kuko-' + kuko.id">
            <td>{{ kuko.id }}</td>
            <td>{{ kuko.external_id }}</td>
            <td>{{ kuko.kuko_type }}</td>
            <td>{{ kuko.kuko_year }}</td>
            <td>{{ kuko.status }}</td>
            <td class="text-right">
              <b-btn size="sm" variant="primary" @click="openKuko(kuko.id)"><fa icon="link"/></b-btn>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr v-for="contract in buyingGroupContracts" :key="'bg-contract-' + contract.id">
            <td>{{ contract.contract_no }}</td>
            <td>{{ contract.type }}</td>
            <td>{{ contract.contract_year }}</td>
            <td>{{ contract.status }}</td>
            <td class="text-right">
              <b-btn size="sm" variant="primary" @click="openContract(contract.id)"><fa icon="link"/></b-btn>
            </td>
          </tr>
        </tbody>
      </table>
    </b-modal>

    <b-modal id="modal-previous-year-kuko" ref="previousYearKukoModal" :ok-only="true" size="lg" :ok-title="$t('core.cancel')"
             :title="$t('sandoz.select_previous_year_kuko')">
      <table class="table table-sm table-hover mb-0">
        <thead>
          <tr>
            <th>{{$t('sandoz.kuko_id')}}</th>
            <th>{{$t('sandoz.customer_external_id')}}</th>
            <th>{{$t('sandoz.kuko_type')}}</th>
            <th>{{$t('sandoz.kuko_year')}}</th>
            <th>{{$t('sandoz.status')}}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="kuko in previousYearKukos" :key="'py-kuko-' + kuko.id">
            <td>{{ kuko.id }}</td>
            <td>{{ kuko.external_id }}</td>
            <td>{{ kuko.kuko_type }}</td>
            <td>{{ kuko.kuko_year }}</td>
            <td>{{ kuko.status }}</td>
            <td class="text-right">
              <b-btn size="sm" variant="primary" :disabled="copyingKuko" @click="copyPreviousYearKuko(kuko.id)"><fa icon="clone"/></b-btn>
            </td>
          </tr>
          <tr v-if="!previousYearKukos.length">
            <td colspan="6" class="text-center text-muted">{{$t('sandoz.no_previous_year_kukos')}}</td>
          </tr>
        </tbody>
      </table>
    </b-modal>
  </form>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import AddressSearch from '../partials/AddressSearch.vue'
import OValueSelectControl from '../../../components/OrticValueSelectControl.vue'
import moment from 'moment'
import {diff} from '~/functions/object.js'
import _ from 'lodash';
import Vue from "vue";
import ContractFile from '../partials/ContractFiles.vue'
import ContractItem from '../partials/ContractItem.vue'
import ContractCloneComparison from './ContractCloneComparison.vue'
import TemplateDownloadButton from '../partials/TemplateDownloadButton.vue'
import contractYearMixin from '../../../mixins/contractYearMixin'

export default {
  mixins: [contractYearMixin],
  components: {
    OValueSelectControl,
    AddressSearch,
    ContractFile,
    ContractItem,
    ContractCloneComparison,
    TemplateDownloadButton
  },
  data: () => ({
    originalKukos: null,
    contractTypes: [],
    years: [],
    item: null,
    customerSizes: [],
    watchers: [],
    saving: false,
    addressIndex: null,
    toggleItems: false,
    listItem: [],
    selectedItems: [],
    searchItem: null,
    months: [],
    loaded: false,
    currentUser: null,
    watcherWorking: false,
    addItemsToAllAddress: false,
    showAddressModeCheckbox: false,
    changeExternalID: false,
    downloadPDF: false,
    itemOld: null,
    languages: [],
    accordionItems: [],
    showContract: null,
    investAccordion:false,
    determErrorID: [],
    wholesalerArray: [],
    titleItems: [],
    disableToDates : {
      to: null
    },
    plan_turnover_outside_range:null,
    plan_turnover_expectation_outside_range:null,
    plan_invest_outside_range:null,
    plan_discount_outside_range:null,
    displayPlanDeviationSkipApproval: false,
    buyingGroupLabel: 'buying_group',
    planData: null,
    activeTab: 0,
    plan_turnover_expectation_condition: null,
    plan_invest_condition: null,
    plan_discount_condition: null,
    heimCustomerSizes: [],
    marketing_activities_percentage: null,
    marketing_activities_otc_percentage: null,
    pdfLoading: false,
    vendorFormLinks: {
      DE: 'https://sandozcollab.sharepoint.com/:w:/r/sites/sandoz-schweiz-intranet/teamsites/Freigegebene%20Dokumente/Marketing/ZZ_NICHT%20LOESCHEN%20ODER%20VERSCHIEBEN/Formular%20f%C3%BCr%20Vendorer%C3%B6ffnung_DE_2024.doc?d=w429524bc2ddd45dcaa24f693c1aaae5b&csf=1&web=1&e=508gVl&xsdata=MDV8MDJ8YmVhdC5zdGVpbmVnZ2VyQHNhbmRvei5jb218NzA0NDBhMWNlMjJkNGRjMmQ5ZDcwOGRlMTFmZjRhN2V8MTVlYWUyY2IxYzk0NGQxZjgwNGZjYjBjMzQ3ZGJkYWR8MHwwfDYzODk2Nzk4NTQ4NTg1NDkxMXxVbmtub3dufFRXRnBiR1pzYjNkOGV5SkZiWEIwZVUxaGNHa2lPblJ5ZFdVc0lsWWlPaUl3TGpBdU1EQXdNQ0lzSWxBaU9pSlhhVzR6TWlJc0lrRk9Jam9pVFdGcGJDSXNJbGRVSWpveWZRPT18MHx8fA%3d%3d&sdata=ZWloUzZNUGk4NWgrRzRvKzFsQmhIeWI3T01rTGpTU1V3M3pEYWI5dGRNQT0%3d',
      FR: 'https://sandozcollab.sharepoint.com/:w:/r/sites/sandoz-schweiz-intranet/teamsites/Freigegebene%20Dokumente/Marketing/ZZ_NICHT%20LOESCHEN%20ODER%20VERSCHIEBEN/Formular%20f%C3%BCr%20Vendorer%C3%B6ffnung_FR_2024.doc?d=w49f246b7c89848be897188826334fc2b&csf=1&web=1&e=pID1ir&xsdata=MDV8MDJ8YmVhdC5zdGVpbmVnZ2VyQHNhbmRvei5jb218NzA0NDBhMWNlMjJkNGRjMmQ5ZDcwOGRlMTFmZjRhN2V8MTVlYWUyY2IxYzk0NGQxZjgwNGZjYjBjMzQ3ZGJkYWR8MHwwfDYzODk2Nzk4NTQ4NTgwMDY5MHxVbmtub3dufFRXRnBiR1pzYjNkOGV5SkZiWEIwZVUxaGNHa2lPblJ5ZFdVc0lsWWlPaUl3TGpBdU1EQXdNQ0lzSWxBaU9pSlhhVzR6TWlJc0lrRk9Jam9pVFdGcGJDSXNJbGRVSWpveWZRPT18MHx8fA%3d%3d&sdata=TFNEOTgyN25YM3ppR2xlVXRxRGpFR0dna3F2YURkV0JRYW9uaktaZFNPND0%3d',
      IT: 'https://sandozcollab.sharepoint.com/:w:/r/sites/sandoz-schweiz-intranet/teamsites/Freigegebene%20Dokumente/Marketing/ZZ_NICHT%20LOESCHEN%20ODER%20VERSCHIEBEN/Formular%20f%C3%BCr%20Vendorer%C3%B6ffnung_IT_2024.doc?d=w6a072b20b8504e1c9ff128710757020e&csf=1&web=1&e=umGkd2&xsdata=MDV8MDJ8YmVhdC5zdGVpbmVnZ2VyQHNhbmRvei5jb218NzA0NDBhMWNlMjJkNGRjMmQ5ZDcwOGRlMTFmZjRhN2V8MTVlYWUyY2IxYzk0NGQxZjgwNGZjYjBjMzQ3ZGJkYWR8MHwwfDYzODk2Nzk4NTQ4NTgzMTc0MnxVbmtub3dufFRXRnBiR1pzYjNkOGV5SkZiWEIwZVUxaGNHa2lPblJ5ZFdVc0lsWWlPaUl3TGpBdU1EQXdNQ0lzSWxBaU9pSlhhVzR6TWlJc0lrRk9Jam9pVFdGcGJDSXNJbGRVSWpveWZRPT18MHx8fA%3d%3d&sdata=b3pRT1dTRXlXcjkwaE5Lbm1tNjFTU0g4SERKd2ZwUzh3bU9RcjhrOGUwWT0%3d'
    },
    fromDateErrorID: [],
    isCommentError: false,
    saveDisabled: false,
    pictures: [],
    paymentSchemas: [],
    addItemController: null,
    reqBiosApoItems: [],
    duplicateContract: false,
    sortalysQuantity: 0,
    sortalysPrice: 0,
    cloneSourceContract: {},
    cloneAvailableMasterIds: [],
    cloneTargetYear: null,
    continueToKuko: false,
    buyingGroupKukos: [],
    buyingGroupContracts: [],
    buyingGroupLinkType: null,
    previousYearKukos: [],
    copyingKuko: false
  }),
  mounted () {
    this.loadData()
  },
  computed: {
    ...mapGetters({
      user: 'auth/user'
    }),
    filteredContractTypes() {
      if (this.$route.params.id === 'new') {
        return this.contractTypes.filter(type => !type.value.endsWith('_KUKO'));
      }
      return this.contractTypes;
    },
    readonly () {
      return this.item && this.item.status != 'Draft' && this.item.status != 'Feedback'
    },
    turnoverExpectionPercentage() {
      if (!this.item.turnover_expectation || !this.item.turnover) {
        return null
      }
      this.item.growth_forecast = this.item.turnover_expectation - this.item.turnover
      this.setTurnoverInvest()
      this.setTurnoverExpectation()
      return Math.round((this.item.turnover_expectation / this.item.turnover - 1) * 10000) / 100 + '%'
    },
    turnoverExpectionPercentageBaseline() {
      if (!this.item.turnover_expectation || this.getPlanDataTurnoverActual() === null || this.getPlanDataTurnoverActual() === 0) {
        return null
      }
      return Math.round((this.item.turnover_expectation / this.getPlanDataTurnoverActual() - 1) * 10000) / 100 + '%'
    },
    investTurnoverPercentage() {
      if (!this.item.invest_turnover_percentage) {
        return null
      }
      return parseFloat(this.item.invest_turnover_percentage * 100).toFixed(2) + '%'
    },
    investGrowthPercentage() {
      if (!this.item.invest_growth) {
        return null
      }
      return parseFloat(this.item.invest_growth * 100).toFixed(2) + '%'
    },
    investMaxPercentage() {
      if (!this.item.invest_max_percentage) {
        return null
      }
      return parseFloat(this.item.invest_max_percentage * 100).toFixed(2) + '%'
    },
    checkPlanDeviationSkipApproval() {

      if(!this.displayBusinessCase() && !this.item.cap_exceeded && (this.item.sales_line && this.item.sales_line.automatic_approval_allowed === true)
      && this.planData !== null && (
      (this.plan_turnover_expectation_condition === true || this.plan_invest_condition === true ||  this.plan_discount_condition === true) &&
      (this.plan_turnover_outside_range !== true && this.plan_turnover_expectation_outside_range !== true && this.plan_invest_outside_range !== true && this.plan_discount_outside_range !== true)
      )
      ){
        return true
      }
      return false
    },
    sortalysContract() {
      return this.item.type === 'HIGHSPEC_SORTALYS' || this.item.type === 'SD_SORTALYS' || this.item.type === 'CNS_SORTALYS' || this.item.type === 'ONCO_SORTALYS' || this.item.type === 'IMMUNO_SORTALYS'
    },
    draftInvoiceAvailable () {
      return this.item.id !== undefined && this.item.contract_year ? moment((this.item.contract_year - 1) + '-12-01').isSameOrBefore(moment().format('YYYY-MM-DD')) : false
    },
    draftInvoiceS1Available () {
      if (!this.item || !this.item.contract_start) {
        return true
      }
      const startMonth = moment(this.item.contract_start).month() + 1
      return startMonth <= 5
    },
    draftInvoiceS1Url () {
      if (!this.item || !this.item.id) {
        return '#'
      }
      return `/api/sandoz/contracts/${this.item.id}/invoice/1/6`
    },
    draftInvoiceS2Url () {
      if (!this.item || !this.item.id) {
        return '#'
      }
      return `/api/sandoz/contracts/${this.item.id}/invoice/7/12`
    },
    draftInvoiceYearUrl () {
      if (!this.item || !this.item.id) {
        return '#'
      }
      return `/api/sandoz/contracts/${this.item.id}/invoice/1/12`
    },
    apoOtcContract() {
      return this.item.type === 'APO_OTC'
    },
    hideItemsTab() {
      if (this.item && this.item.type && this.item.type.endsWith('_KUKO')) {
        // If sales_line is loaded and count is 0, hide.
        if (this.item.sales_line && this.item.sales_line.product_masters_count == 0) {
          return true
        }
        // If sales_line is not yet loaded for a Kuko type, we might want to hide it by default 
        // if we know these types usually don't have items. 
        // But for now, let's just make sure we check the count correctly.
      }
      return false
    },
    kukoErrorMessage() {
      if (this.item && this.item.type && (this.item.status === 'Draft' || this.item.status === 'Feedback')) {
        const hasKukos = this.item.kukos && this.item.kukos.length > 0;

        if (this.item.type.endsWith('_KUKO') && !hasKukos) {
          return this.$i18n.t('sandoz.kuko_not_linked')
        }
        
        if (hasKukos) {
          const validKukos = this.item.kukos.filter(k => k.status !== 'Rejected' && k.status !== 'Cancelled')
          
          const hasUnapproved = validKukos.some(k => {
            return k.status !== 'Approved' && k.status !== 'Stored' && k.status !== 'Contract Approval Pending'
          })
          
          if (hasUnapproved && validKukos.length > 0) {
            return this.$i18n.t('sandoz.waiting_kuko_approval')
          }
        }
      }
      return null
    }
  },
  watch: {
    'item.contract_start': function (newVal) {
      let startDate = moment(newVal);
      //const marchEndDate = moment(startDate.format('YYYY') + "-03-31")
      // if(startDate < marchEndDate) {
      //   this.item.contract_start = moment().year() + '-01-01'
      // }
      this.disableToDates.to = new Date(startDate.format('YYYY'), startDate.month(), startDate.format('D'))
      this.setContractDateToItems(newVal)
      if(this.item && (this.item.status == 'Draft' || this.item.status == 'Feedback')) {
        this.loadplanData()
      }

    },
    'item.contract_expiration': function (newVal) {
      this.setContractDateToItems(newVal)
      if(this.item && (this.item.status == 'Draft' || this.item.status == 'Feedback')) {
        this.loadplanData()
      }
    },
    item: {
      handler(newVal) {
        if (newVal && newVal.kukos) {
          const sum = newVal.kukos.reduce((total, kuko) => total + (parseInt(kuko.discount_lower_100) || 0), 0)
          if (newVal.discount !== sum) {
            newVal.discount = sum
          }
        }
      },
      deep: true
    },
    saving: function (newVal, oldVal) {
      const self = this
      if (!newVal) {
        setTimeout(function (){
          self.pdfLoading = newVal
        }, 1000)
      } else {
        self.pdfLoading = newVal
      }
    }
  },
  created () {
    this.updateContractYears()

    this.contractTypes = [
      { value: 'APO', text: this.$i18n.t('sandoz.apo') },
      { value: 'SD', text: this.$i18n.t('sandoz.sd') },
      { value: 'IMMUNO', text: this.$i18n.t('sandoz.immuno') },
      { value: 'ONCO', text: this.$i18n.t('sandoz.onco') },
      { value: 'CNS', text: this.$i18n.t('sandoz.cns') },
      { value: 'HEIM', text: this.$i18n.t('sandoz.heim') },
      { value: 'SD_SORTALYS', text: this.$i18n.t('sandoz.sd_sortlays')} ,
      { value: 'CNS_SORTALYS', text: this.$i18n.t('sandoz.cns_sortlays') },
      { value: 'IMMUNO_SORTALYS', text: this.$i18n.t('sandoz.immuno_sortlays') },
      { value: 'BIOS_APO', text: this.$i18n.t('sandoz.bios_apo') },
      { value: 'HIGHSPEC_SORTALYS', text: this.$i18n.t('sandoz.highspec_sortalys') },
      { value: 'APO_OTC', text: this.$i18n.t('sandoz.apo_otc') },
      { value: 'APO_KUKO', text: this.$i18n.t('sandoz.apo_kuko') },
      { value: 'SD_KUKO', text: this.$i18n.t('sandoz.sd_kuko') },
      { value: 'IMMUNO_KUKO', text: this.$i18n.t('sandoz.immuno_kuko') },
      { value: 'HOSP_KUKO', text: this.$i18n.t('sandoz.hosp_kuko') },
      { value: 'CNS_KUKO', text: this.$i18n.t('sandoz.cns_kuko') },
    ]

    this.months = [
      { value: '01', text: this.$i18n.t('core.january_short') },
      { value: '02', text: this.$i18n.t('core.february_short') },
      { value: '03', text: this.$i18n.t('core.march_short') },
      { value: '04', text: this.$i18n.t('core.april_short') },
      { value: '05', text: this.$i18n.t('core.may_short') },
      { value: '06', text: this.$i18n.t('core.june_short') },
      { value: '07', text: this.$i18n.t('core.july_short') },
      { value: '08', text: this.$i18n.t('core.august_short') },
      { value: '09', text: this.$i18n.t('core.september_short') },
      { value: '10', text: this.$i18n.t('core.october_short') },
      { value: '11', text: this.$i18n.t('core.november_short') },
      { value: '12', text: this.$i18n.t('core.december_short') }
    ]

    this.languages = [
      {value: 'DE', text: 'DE'},
      {value: 'FR', text: 'FR'},
      {value: 'IT', text: 'IT'}
    ]

    this.paymentSchemas = [
      {value: 'semester', text: this.$i18n.t('sandoz.semester')},
      {value: 'yearly', text: this.$i18n.t('sandoz.yearly')}
    ]
  },
  methods: {
    hasPermission(item) {
      let result = true
      let permissions = item
      let user = this.user
      if (!user.is_super_user && permissions) {
        permissions.forEach((permission) => {
          if (!user.routePermissions.includes(permission)) {
            result = false
          }
        })
      }
      return result
    },
    loadData () {
      this.saving = true
      var url = `/api/sandoz/ice-peak/contracts/${this.$route.params.id}?include=word_files.user,pdfs.user`
      this.url = url
      axios
        .get(url)
        .then((response) => {
          var item = response
          if (this.dataKey) {
            item = response[this.dataKey]
          }
          this.item = item.data
          this.originalKukos = null // Reset so loadKukoDiscount picks up fresh saved KUKOs
          this.updateContractYears()

          // set default user
          if (!this.item.user_id) {
            this.item.user_id = this.user.id
          }

          if(this.item.payment_schema === null || this.item.payment_schema === undefined) {
            this.item.payment_schema = 'yearly'
          }

          this.getWholesalers()
          this.setTitleItems()
          this.loadKukoDiscount()
          this.loadplanData()
          this.checkBudgetUsedup()
          this.compareTurnoverExpectationForOTC()
          this.compareMarketingActivityForOTC()
          this.loadBuyingGroupLinks()

          var partners = [1,2,3,4,5,6,7];
          for(var i=1; i<=partners.length; i++) {
            this.item['contract_partner_' + i + '_title_dropdown'] = null
          }
          // Clone flow: if ?from= is set, fetch clone preview first to create addresses
          // so that addItemsToAddresses has delivery addresses to populate items into
          if (this.$route.query.from && this.$route.params.id === 'new') {
            if (this.$route.query.type) {
              this.item.type = this.$route.query.type
            }
            if (this.$route.query.year) {
              this.item.contract_year = parseInt(this.$route.query.year)
            }

            // Show comparison modal immediately with a loading spinner
            this.$nextTick(() => {
              this.$refs.cloneComparison.show()
              this.$refs.cloneComparison.loading = true
            })

            axios.post('/api/sandoz/ice-peak/contracts/clone-preview', {
              source_contract_id: this.$route.query.from,
              target_year: this.$route.query.year || this.item.contract_year,
              target_type: this.$route.query.type || null
            }).then((cloneResponse) => {
              this.cloneSourceContract = cloneResponse.data.source_contract.data || cloneResponse.data.source_contract
              this.cloneAvailableMasterIds = cloneResponse.data.available_product_master_ids
              this.cloneTargetYear = cloneResponse.data.target_year

              const meta = cloneResponse.data.source_contract_metadata || {}

              // Pre-fill external_id: use query param override, or fall back to source contract
              this.item.customer_external_id = this.$route.query.external_id || meta.customer_external_id || ''
              // Pre-fill language from source contract
              if (meta.language) {
                this.item.language = meta.language
              }

              // Generate contract number (watchers aren't enabled yet, so call manually)
              this.setContractNo()

              // Create addresses from the source contract so addItemsToAddresses has delivery addresses
              const sourceAddresses = this.cloneSourceContract.addresses || []
              this.item.addresses = sourceAddresses.map((addr, i) => ({
                del_address: i + 1,
                address_type: addr.address_type || 'delivery',
                company_name: addr.company_name,
                street: addr.street,
                zip: addr.zip,
                city: addr.city,
                customer_external_id: addr.customer_external_id,
                customer_external_id_hcp: addr.customer_external_id_hcp,
                customer_size: addr.customer_size,
                default_customer_size: addr.default_customer_size,
                fte: addr.fte,
                number_of_hcps: addr.number_of_hcps,
                items: []
              }))

              this.getAddressItemData()
            }).catch(() => {
              this.getAddressItemData()
            })
          } else {
            this.getAddressItemData()
          }
        })
    },
    loadClonePreview (sourceContractId) {
      // Modal was already shown with a loading spinner in loadData
      // Now data is loaded, just stop the spinner
      this.$nextTick(() => {
        this.$refs.cloneComparison.loading = false
      })
    },
    onCloneConfirm () {
      // Copy quantities from source contract to the loaded items
      this.copyQuantitiesFromSource()
      this.$nextTick(() => {
        if (this.$refs.contractItem) {
          this.$refs.contractItem.setQuantityChildParent()
          this.$refs.contractItem.setQuantityToChildSpecialLoad()
          this.$refs.contractItem.$forceUpdate()
        }
      })
    },
    copyQuantitiesFromSource () {
      if (!this.cloneSourceContract || !this.cloneSourceContract.addresses) return

      // Build a map of product_master_id -> delivery data from source contract
      const sourceQtyMap = {}
      this.cloneSourceContract.addresses.forEach(addr => {
        if (!addr.items) return
        const collectItems = (items) => {
          items.forEach(item => {
            if (item.product_master_id && item.delivery) {
              sourceQtyMap[item.product_master_id] = item.delivery
            }
            if (item.children && item.children.length) {
              collectItems(item.children)
            }
          })
        }
        collectItems(addr.items)
      })

      // Apply quantities to the new contract's items
      // Delivery structure uses nested objects: delivery.q1.quantity, delivery.q2.quantity, etc.
      if (!this.item.addresses) return
      const self = this
      this.item.addresses.forEach((addr, addrIndex) => {
        if (!addr.items) return
        const applyQty = (items) => {
          items.forEach(item => {
            const src = sourceQtyMap[item.product_master_id]
            if (src) {
              if (!item.delivery) {
                self.$set(item, 'delivery', {})
              }
              // Copy quarterly quantities
              const quarters = ['q1', 'q2', 'q3', 'q4']
              quarters.forEach(q => {
                if (src[q] && src[q].quantity) {
                  if (!item.delivery[q]) {
                    self.$set(item.delivery, q, {})
                  }
                  self.$set(item.delivery[q], 'quantity', src[q].quantity)
                }
              })
              // Copy yearly quantity
              if (src.yearly && src.yearly.quantity) {
                if (!item.delivery.yearly) {
                  self.$set(item.delivery, 'yearly', {})
                }
                self.$set(item.delivery.yearly, 'quantity', src.yearly.quantity)
              }
              // Trigger price calculation
              if (self.$refs.contractItem) {
                self.$refs.contractItem.setPrice(item, addrIndex, 'yearly')
              }
            }
            if (item.children && item.children.length) {
              applyQty(item.children)
            }
          })
        }
        applyQty(addr.items)
      })
    },
    getAddressItemData () {
      var url = `/api/sandoz/ice-peak/contracts/detail/${this.$route.params.id}`
      axios
        .get(url)
        .then((response) => {
          var item = response
          // Don't overwrite addresses during clone flow — they were already created from the source contract
          if (!(this.$route.query.from && this.$route.params.id === 'new' && this.item.addresses && this.item.addresses.length > 0)) {
            this.item.addresses = item.data.addresses
          }
          var dbItem = Object.assign({}, this.item)
          this.$nextTick(() => {
            this.loaded = true
            this.addItemsToAddresses(false)
            this.setDefaultPrice()
            this.setContractDateToItems()
            if (this.$refs.contractItem) {
              this.$refs.contractItem.setQuantityChildParent(1)
              this.$refs.contractItem.setQuantityToChildSpecialLoad()
            }
            this.enableWatchers()
            if (this.$refs.contractItem) {
              this.$refs.contractItem.setSelectedItemPrice()
            }
            this.duplicateContractCheck()
            this.$nextTick(() => {
              this.itemOld = {...this.item}
              this.itemOld.marketing_activities = Math.round(dbItem.marketing_activities)
              this.saving = false
              if (this.$refs.contractItem) {
                this.$refs.contractItem.$forceUpdate()
              }

              // Clone flow: load comparison modal after items are fully loaded
              if (this.$route.query.from && this.$route.params.id === 'new') {
                this.loadClonePreview(this.$route.query.from)
              }
            })
          })
        })
    },
    setBuyingGroupLabel () {
      if (['SD', 'CNS', 'ONCO', 'IMMUNO'].includes(this.item.type)) {
        this.buyingGroupLabel = 'customer_group'
      } else {
        this.buyingGroupLabel = 'buying_group'
      }
    },
    loadBuyingGroupLinks () {
      this.buyingGroupKukos = []
      this.buyingGroupContracts = []
      if (!this.item.buying_group_code_when_uploaded || !this.item.contract_year) {
        return
      }
      axios.post('/api/sandoz/ice-peak/contracts/buying-group-links', {
        buying_group_code: this.item.buying_group_code_when_uploaded,
        contract_year: this.item.contract_year,
        contract_id: this.item.id || null,
        kuko_id: this.item.kuko_id || null
      }).then((response) => {
        this.buyingGroupKukos = response.data.kukos || []
        this.buyingGroupContracts = response.data.contracts || []
      })
    },
    openBuyingGroupLinks (type) {
      this.buyingGroupLinkType = type
      if (type === 'kuko') {
        if (this.buyingGroupKukos.length === 1) {
          this.openKuko(this.buyingGroupKukos[0].id)
          return
        }
      } else {
        if (this.buyingGroupContracts.length === 1) {
          this.openContract(this.buyingGroupContracts[0].id)
          return
        }
      }
      this.$refs.buyingGroupLinksModal.show()
    },
    openKuko (id) {
      const href = this.$router.resolve({ name: 'sandoz.kuko.detail', params: { id } }).href
      window.open(href, '_blank')
    },
    openContract (id) {
      const href = this.$router.resolve({ name: 'sandoz.ice_peak.contract_view', params: { id } }).href
      window.open(href, '_blank')
    },
    enableWatchers () {
      this.watchers.push(this.$watch('item.type', (newVal) => {
        this.handleTypeChange(newVal)
        this.setBuyingGroupLabel()
        this.setContractNo()
        this.checkBudgetUsedup()
        this.duplicateContractCheck()
      }))
      this.watchers.push(this.$watch('item.customer_external_id', (newVal) => {
        this.changeExternalID = true
        this.setContractNo()
        this.setPreviousContract();
        this.duplicateContractCheck()
        this.$set(this.item, 'kuko_link', null)
        this.$set(this.item, 'kuko_id', null)
        this.item.kuko_status = null
        this.loadKukoDiscount()
      }))
      this.watchers.push(this.$watch('item.contract_year', (newVal) => {
        this.setContractNo()
        this.setPreviousContract()
        this.addItemsToAddresses()
        this.changeContractDuration()
        this.$set(this.item, 'kuko_link', null)
        this.$set(this.item, 'kuko_id', null)
        this.item.kuko_status = null
        this.loadKukoDiscount()
        this.loadplanData()
        this.duplicateContractCheck()
        this.checkBudgetUsedup()
        this.setApprovers()
        this.loadBuyingGroupLinks()
      }))
      this.watchers.push(this.$watch('item.discount', (newVal) => {
        this.setApprovers()
      }))
      this.watchers.push(this.$watch('item.marketing_activities', (newVal) => {
        this.setApprovers()
        this.updateMarketingActivitiesMaximumOTC()
      }))
      this.watchers.push(this.$watch('item.type', (newVal) => {
        this.setApprovers()
        this.setPreviousContract()
        this.loadplanData()
        this.$set(this.item, 'kuko_link', null)
        this.$set(this.item, 'kuko_id', null)
        this.item.kuko_status = null
        this.loadKukoDiscount()
      }))
      this.watchers.push(this.$watch('currentUser', (newVal) => {
        this.setApprovers()
      }))
      this.watchers.push(this.$watch('item.invest_max', (newVal) => {
        this.setApprovers()
      }))
      this.watchers.push(this.$watch('item.marketing_activities', (newVal) => {
        this.setApprovers()
      }))
      this.watchers.push(this.$watch('item.type', (newVal) => {
        this.addItemsToAddresses()
      }))
      this.watchers.push(this.$watch('item.type', (newVal) => {
        this.setTurnoverInvest()
      }))
      this.watchers.push(this.$watch('item.type', (newVal) => {
        this.setTurnoverExpectation()
      }))
      this.watchers.push(this.$watch('item.turnover', (newVal) => {
        if (!this.item.turnover_expectation) {
          return
        }
        this.item.growth_forecast = this.item.turnover_expectation - newVal
        this.setTurnoverInvest()
      }))
      this.watchers.push(this.$watch('item.turnover_expectation', (newVal) => {
        if(newVal > 0 && newVal !== null) {
          this.setWithoutWatcher('marketing_activities_percentage', this.item.marketing_activities_maximum / newVal)
          this.setWithoutWatcher('marketing_activities_otc_percentage', this.item.marketing_activities_otc / newVal)
        } else {
          this.setWithoutWatcher('marketing_activities_percentage', null)
          this.setWithoutWatcher('marketing_activities_otc_percentage', null)
        }

        if (!this.item.turnover) {
          return
        }

        this.item.growth_forecast = newVal - this.item.turnover
        this.setTurnoverInvest()
        this.compareTurnoverExpectationForOTC()
      }))
      this.watchers.push(this.$watch('item.growth_forecast', (newVal) => {
        this.setTurnoverExpectation()
      }))
      this.watchers.push(this.$watch('item.marketing_activities_percentage', (newVal) => {
        if (this.sortalysContract) {
          return
        }
        this.setWithoutWatcher('marketing_activities_maximum', newVal * this.item.turnover_expectation)
      }))
      this.watchers.push(this.$watch('item.marketing_activities_maximum', (newVal) => {
        if(this.item.turnover_expectation > 0 && this.item.turnover_expectation !== null) {
          this.setWithoutWatcher('marketing_activities_percentage', newVal / this.item.turnover_expectation)
        }
        this.setApprovers()
        this.checkBudgetUsedup()
      },{ immediate: true }))

      this.watchers.push(this.$watch('item.marketing_activities_otc', (newVal) => {

        if(this.item.turnover_expectation > 0 && this.item.turnover_expectation !== null) {
          this.setWithoutWatcher('marketing_activities_otc_percentage', newVal / this.item.turnover_expectation)
        } else {
          this.setWithoutWatcher('marketing_activities_otc_percentage', null)
        }

        this.updateMarketingActivitiesMaximumOTC()
        this.compareMarketingActivityForOTC()

        if(this.item.marketing_activities_maximum && this.item.turnover_expectation) {
          this.item.marketing_activities_percentage = this.item.marketing_activities_maximum / this.item.turnover_expectation
        }
        this.setApprovers()
        this.checkBudgetUsedup()
      },{ immediate: true }))
      this.watchers.push(this.$watch('item.invest_turnover', (newVal) => {
        this.setCalculatedInvest()
        this.setApprovers()
      },{ immediate: true }))
      this.watchers.push(this.$watch('item.invest_turnover_forecast', (newVal) => {
        this.setCalculatedInvest()
        this.setApprovers()
      },{ immediate: true }))

      this.watchers.push(this.$watch('item.new_customer', (newVal) => {
        if(newVal === null) {
          this.setPreviousContract(true)
          this.item.no_previous_contract  = false
        } else {
          this.item.no_previous_contract  = true
        }
      }))
      this.watchers.push(this.$watch('item.language', (newVal) => {
        this.addItemsToAddresses()
        this.setTitleItems()
      }))
      this.watchers.push(this.$watch('item.plan_deviation_skip_approval', (newVal) => {
        this.setApprovers()
      }))

      this.watchers.push(this.$watch('planData', (newVal) => {
        this.setTurnoverInvest()
        this.setTurnoverExpectation()
      }))

      this.watchers.push(this.$watch('item.discount', (newVal) => {
        this.checkBudgetUsedup()
      }))
    },
    setCalculatedInvest() {
      if (!this.item.invest_turnover) {
        return
      }
      if (!this.item.invest_turnover_forecast) {
        return
      }

      this.item.invest_max = parseFloat(this.item.invest_turnover) + parseFloat(this.item.invest_turnover_forecast)
      this.item.invest_max_percentage = this.item.invest_max / parseFloat(this.item.turnover_expectation)

      this.$forceUpdate()
    },
    disableWatchers () {

    },
    contractCanApprovable() {
      if (this.kukoErrorMessage) {
        this.$notify({
          title: this.$i18n.t('core.save_error'),
          text: this.kukoErrorMessage,
          type: 'error'
        })
        return
      }

      if(this.item.contract_start && moment().isAfter(this.item.contract_start)) {
        if(this.user.is_super_user) {
          this.$refs.pastContractModel.show()
          return
        } else {
          if(this.checkFromDate()) {
            this.activeTab = 2
            this.$notify({
              title: this.$i18n.t('core.save_error'),
              text: this.$i18n.t('sandoz.from_date_error'),
              type: 'error'
            })
            return
          }
        }
      }

      this.saveAndStartApproval()
    },
    saveAndStartApproval () {
      if(this.checkRequiredInBiosApoItem()) {
        if (this.$refs.pastContractModel && this.$refs.pastContractModel.isVisible) {
          this.$refs.pastContractModel.hide()
        }
        this.$notify({
          title: this.$i18n.t('core.validation_error'),
          text: this.$i18n.t('core.validation_error_text', { message: this.$i18n.t('sandoz.req_bios_apo_error') }),
          type: 'error'
        })
        return
      } else {
        this.reqBiosApoItems = []
      }

      if(this.$refs.contractItem && this.$refs.contractItem.marketingActivityTotalAvailable() !== 0) {
        this.$notify({
          title: this.$i18n.t('core.save_error'),
          text: this.$i18n.t('sandoz.market_activity_mismatch'),
          type: 'error'
        })
        return
      }
      if(this.item.contract_start && moment().isAfter(this.item.contract_start)) {
        if (this.user.is_super_user && !this.item.super_user_comment) {
          this.activeTab = 0
          this.isCommentError = true
          this.$notify({
            title: this.$i18n.t('core.save_error'),
            text: this.$i18n.t('sandoz.super_user_comment_error'),
            type: 'error'
          })
          return
        }
      }

      // check bank information mandatory
      if (this.item.sales_line && this.item.sales_line.bank_information_mandatory === true) {
        let hasSelectedQuantity = false
        if (this.item.addresses && this.item.addresses.length) {
          for (let address of this.item.addresses) {
            if (address.address_type === 'delivery' && address.items && address.items.length) {
              for (let item of address.items) {
                const q1 = item.delivery && item.delivery.q1 ? Number(item.delivery.q1.quantity || 0) : 0
                const q2 = item.delivery && item.delivery.q2 ? Number(item.delivery.q2.quantity || 0) : 0
                const q3 = item.delivery && item.delivery.q3 ? Number(item.delivery.q3.quantity || 0) : 0
                const q4 = item.delivery && item.delivery.q4 ? Number(item.delivery.q4.quantity || 0) : 0
                const yearly = item.delivery && item.delivery.yearly ? Number(item.delivery.yearly.quantity || 0) : 0

                if (q1 > 0 || q2 > 0 || q3 > 0 || q4 > 0 || yearly > 0) {
                  hasSelectedQuantity = true
                  break
                }

                if (item.children) {
                  for (let subItem of item.children) {
                    const sq1 = subItem.delivery && subItem.delivery.q1 ? Number(subItem.delivery.q1.quantity || 0) : 0
                    const sq2 = subItem.delivery && subItem.delivery.q2 ? Number(subItem.delivery.q2.quantity || 0) : 0
                    const sq3 = subItem.delivery && subItem.delivery.q3 ? Number(subItem.delivery.q3.quantity || 0) : 0
                    const sq4 = subItem.delivery && subItem.delivery.q4 ? Number(subItem.delivery.q4.quantity || 0) : 0
                    const syearly = subItem.delivery && subItem.delivery.yearly ? Number(subItem.delivery.yearly.quantity || 0) : 0

                    if (sq1 > 0 || sq2 > 0 || sq3 > 0 || sq4 > 0 || syearly > 0) {
                      hasSelectedQuantity = true
                      break
                    }

                    if (subItem.children) {
                      for (let childItem of subItem.children) {
                        const cq1 = childItem.delivery && childItem.delivery.q1 ? Number(childItem.delivery.q1.quantity || 0) : 0
                        const cq2 = childItem.delivery && childItem.delivery.q2 ? Number(childItem.delivery.q2.quantity || 0) : 0
                        const cq3 = childItem.delivery && childItem.delivery.q3 ? Number(childItem.delivery.q3.quantity || 0) : 0
                        const cq4 = childItem.delivery && childItem.delivery.q4 ? Number(childItem.delivery.q4.quantity || 0) : 0
                        const cyearly = childItem.delivery && childItem.delivery.yearly ? Number(childItem.delivery.yearly.quantity || 0) : 0

                        if (cq1 > 0 || cq2 > 0 || cq3 > 0 || cq4 > 0 || cyearly > 0) {
                          hasSelectedQuantity = true
                          break
                        }
                      }
                    }
                    if (hasSelectedQuantity) break
                  }
                }
                if (hasSelectedQuantity) break
              }
            }
            if (hasSelectedQuantity) break
          }
        }

        if (hasSelectedQuantity) {
          const validations = [
            { field: 'bank_name', message: this.$i18n.t('sandoz.bank_name_required') },
            { field: 'bank_address', message: this.$i18n.t('sandoz.bank_address_required') },
            { field: 'accountholder_name', message: this.$i18n.t('sandoz.account_holder_name_required') },
            { field: 'accountholder_address', message: this.$i18n.t('sandoz.account_holder_address_required') },
            { field: 'iban_no', message: this.$i18n.t('sandoz.iban_no_required') },
          ]

          for (let v of validations) {
            const value = this.item[v.field]

            if (!value || value.trim() === '' || value.trim() === null) {
              this.$notify({
                title: this.$i18n.t('core.validation_error'),
                text: this.$i18n.t('core.validation_error_text', { message: v.message }),
                type: 'error'
              })
              return
            }
          }
        }
      }

      this.item.status = 'Committed'
      this.save()
    },
    checkFromDate() {
      const self = this
      if(self.item.addresses) {
        const now = new Date()
        let fromDateError = false

        let currentMonth = now.getMonth() + 1
        currentMonth = (currentMonth < 10 ? '0' + currentMonth : currentMonth).toString()
        let currentYear = now.getFullYear().toString()

        self.fromDateErrorID = []
        self.item.addresses.forEach(function (address) {
          if(address.address_type === 'delivery') {
            address.items.forEach(function (line) {
              if(line.type === 'marketing_activity' &&
                  ((line.valid_from_year === currentYear && line.valid_from_month <= currentMonth) || line.valid_from_year < currentYear) &&
                  (line.exist_value === null && (line.contract_line_exist_attribute === 'indeterminate' || !line.contract_line_exist_attribute)) &&
                  (line.delivery && line.delivery['yearly'].quantity !== null || line.delivery['q1'].quantity !== null || line.delivery['q2'].quantity !== null || line.delivery['q3'].quantity !== null || line.delivery['q4'].quantity !== null)
              ) {
                self.fromDateErrorID.push(address.id+'-'+line.product.id)
                fromDateError = true
              }

              if(line.children && Object.keys(line.children).length) {
                line.children.forEach(function (subLine) {

                  if(subLine.type === 'marketing_activity' &&
                      ((subLine.valid_from_year === currentYear && subLine.valid_from_month <= currentMonth) || subLine.valid_from_year < currentYear) &&
                      (subLine.exist_value === null && (subLine.contract_line_exist_attribute === 'indeterminate' || !subLine.contract_line_exist_attribute)) &&
                      (subLine.delivery && subLine.delivery['yearly'].quantity !== null || subLine.delivery['q1'].quantity !== null || subLine.delivery['q2'].quantity !== null || subLine.delivery['q3'].quantity !== null || subLine.delivery['q4'].quantity !== null)
                  ) {
                    self.fromDateErrorID.push(address.id+'-'+subLine.product.id)
                    fromDateError = true
                  }

                  if(subLine.children && Object.keys(subLine.children).length) {
                    subLine.children.forEach(function (childLine) {
                      if(childLine.type === 'marketing_activity' &&
                          ((childLine.valid_from_year === currentYear && childLine.valid_from_month <= currentMonth) || childLine.valid_from_year < currentYear) &&
                          (childLine.exist_value === null && (childLine.contract_line_exist_attribute === 'indeterminate' || !childLine.contract_line_exist_attribute)) &&
                          (childLine.delivery && childLine.delivery['yearly'].quantity !== null || childLine.delivery['q1'].quantity !== null || childLine.delivery['q2'].quantity !== null || childLine.delivery['q3'].quantity !== null || childLine.delivery['q4'].quantity !== null)
                      ) {
                        self.fromDateErrorID.push(address.id+'-'+childLine.product.id)
                        fromDateError = true
                      }
                    })
                  }
                })
              }
            })
          }
        })
        return fromDateError
      }
    },
    resetToDraft () {
      const oldStatus = this.item.status
      this.item.status = 'Draft'

      this.item.approval_date_1 = null
      this.item.approval_person_1 = null

      this.item.approval_date_2 = null
      this.item.approval_person_2 = null

      this.item.approval_date_3 = null
      this.item.approval_person_3 = null

      this.item.approval_date_4 = null
      this.item.approval_person_4 = null

      this.item.approval_date_5 = null
      this.item.approval_person_5 = null

      this.item.approval_date_6 = null
      this.item.approval_person_6 = null

      this.item.next_approver = null

      if(oldStatus === 'Signed' || oldStatus === 'Approved') {
        this.item.contract_version = (!this.item.contract_version || this.item.contract_version == 1) ? 2 : this.item.contract_version + 1
      }
      this.save(true)
      this.$refs.resetContractModel.hide()
    },
    save (skipValidation = false) {
      var url = `/api/sandoz/ice-peak/contracts/${this.$route.params.id}?include=word_files.user`
      // var url = this.url
      var route = this.$route

      // this happens if we create a new data record and update it right away without navigating way. We'll still have
      // new in our url, but we don't want to create a new record, we want to update the record we just created.
      // @TODO we should do this in a more elegant way that doesn't require search & replace
      if (url.indexOf('/new') > 0 && 'id' in this.item) {
        url = url.replace('/new', '/' + this.item.id)
      }

      var root = this.$root
      var self = this

      if(!skipValidation) {
        if(self.item.type ===  null) {
          self.$notify({
            title: self.$i18n.t('core.validation_error'),
            text: self.$i18n.t('core.validation_error_text', { message: self.$i18n.t('sandoz.type_required') }),
            type: 'error'
          })
          return
        }

        if(self.item.customer_external_id ===  null) {
          self.$notify({
            title: self.$i18n.t('core.validation_error'),
            text: self.$i18n.t('core.validation_error_text', { message: self.$i18n.t('sandoz.external_id_required') }),
            type: 'error'
          })
          return
        }

        if(self.item.contract_year ===  null) {
          self.$notify({
            title: self.$i18n.t('core.validation_error'),
            text: self.$i18n.t('core.validation_error_text', { message: self.$i18n.t('sandoz.contract_year_required') }),
            type: 'error'
          })
          return
        }

        if(self.item.new_customer === 'NA') {
          self.$notify({
            title: self.$i18n.t('core.validation_error'),
            text: self.$i18n.t('core.validation_error_text', { message: self.$i18n.t('sandoz.new_customer_required') }),
            type: 'error'
          })
          return
        }

        if(self.showBusinessCase() && (self.item.reason_businesscase === '' || self.item.reason_businesscase === null)) {
          self.$notify({
            title: self.$i18n.t('core.validation_error'),
            text: self.$i18n.t('core.validation_error_text', { message: self.$i18n.t('sandoz.reason_businesscase_required') }),
            type: 'error'
          })
          return
        }

        if(self.item.new_customer === null && (self.item.previous_contract === undefined || self.item.previous_contract === null)) {
          self.$notify({
            title: self.$i18n.t('core.validation_error'),
            text: self.$i18n.t('core.validation_error_text', { message: self.$i18n.t('sandoz.previous_contract_required') }),
            type: 'error'
          })
          return
        }

        if(!self.sortalysContract) {
          var indeterminantEror = self.checkIndeterminantCheckbox();
          if(indeterminantEror) {
            self.$notify({
              title: self.$i18n.t('core.validation_error'),
              text: self.$i18n.t('core.validation_error_text', { message: self.$i18n.t('sandoz.indeterminat_error') }),
              type: 'error'
            })
            return
          }
        }
      }

      this.disableWatchers()
      if (this.$refs.pastContractModel && this.$refs.pastContractModel.isVisible) {
        this.$refs.pastContractModel.hide()
      }
      this.saving = true
      this.showContract = null

      if(!this.showBusinessCase()) {
        this.item.reason_businesscase = null
      }

      axios
        .post(url, this.item)
        .then((response) => {
          let savedItem = response.data
          // this.item = response.data

          // assign our new id to the route params and item in case someone wants to work with it
          if ('id' in response.data) {
            route.params.id = response.data.id
            this.$set(this.item, 'id', response.data.id)
          }

          if ('updated_at' in response.data) {
            this.$set(this.item, 'updated_at', response.data.updated_at)
          }

          this.$notify({
            title: self.$i18n.t('core.saved'),
            text: self.$i18n.t('core.saved_text')
          })

          // remove all error states
          var elements = document.querySelectorAll('.has-error')
          elements.forEach((element) => {
            element.classList.remove('has-error')
          })
          this.fromDateErrorID = []
          this.isCommentError = false

          this.showDeletedFiles = false
          this.showDeletedPDFFiles = false
          this.reqBiosApoItems = []

          // clear all errors
          root.errors = {}
          if(this.downloadPDF) {
            this.pdfContract()
            this.$nextTick(function (){
              this.itemOld = {...this.item}
              this.downloadPDF = false
            })
          } else {
            this.loaded = true
            this.setWholesalers(savedItem)
            this.getAddressItemData()
          }

          if (this.continueToKuko) {
            this.continueToKuko = false
            this.createKuko()
          }
        })
        .catch((error) => {
          // stop loading indicator
          self.saving = false

          if (error.response.status === 409) {
            this.$bvModal.msgBoxConfirm(self.$i18n.t('core.concurrent_modification_text') || 'Data was changed by another process. Do you want to reload the page to see the new data?', {
                title: self.$i18n.t('core.concurrent_modification') || 'Data Changed',
                size: 'md',
                buttonSize: 'sm',
                okVariant: 'primary',
                okTitle: self.$i18n.t('core.reload') || 'Reload Page',
                cancelTitle: self.$i18n.t('core.cancel') || 'Cancel',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            }).then(value => {
                if(value) {
                    window.location.reload();
                }
            })
          } else if (error.response.status === 422 && 'data' in error.response && 'message' in error.response.data) {
            this.$notify({
              title: self.$i18n.t('core.validation_error'),
              text: self.$i18n.t('core.validation_error_text', { message: error.response.data.message }),
              type: 'error'
            })
            if ('data' in error.response && 'errors' in error.response.data) {
              root.errors = error.response.data.errors
            }
          } else {
            if(error.response.data && 'contract_error' in error.response.data && error.response.data.contract_error === 'contract_already_exists') {
              this.showContract = error.response.data.contract
              this.$refs.duplicateContractModel.show()
            } else {
              this.$notify({
                title: self.$i18n.t('core.save_error'),
                text: self.$i18n.t('core.save_error_text', { url: this.url }),
                type: 'error'
              })
            }
          }
        })
    },
    back () {
      this.$router.back()
    },
    addAddress () {
      this.addressMode = 'delivery'
      this.showAddressModeCheckbox = false
      this.$refs.addressSearch.showAddressSearchModal(this)
    },
    setContractNo () {
      if (!this.item.type || !this.item.customer_external_id) {
        return
      }
      this.item.contract_no = `${this.item.type}-${this.item.contract_year - 2000}-${this.item.customer_external_id}`
    },
    setCurrentUser(user) {
      if (!user) {
        return
      }
      this.currentUser = user

      if (user.flm && user.flm.data && user.flm.data.flm_role) {
        this.item.flm_role = user.flm.data.flm_role
        if(this.itemOld && this.itemOld.flm_role) {
          this.itemOld.flm_role = user.flm.data.flm_role
        }
      }

      if (user.regions && user.regions.data && Object.keys(user.regions.data).length) {
        this.item.region_id = user.regions.data[0].region_id
      } else {
        this.item.region_id = null
      }
    },
    setApprover(num, val) {
      if (this.item['approver_' + num] != val) {
        this.item['approver_' + num] = val

        // clear existing
        for (let i = num; i < 6; i++) {
          this.item['approval_date_' + i] = null
          this.item['approval_person_' + i] = null
        }

        // reset next approver if needed
        this.item.next_approver = Math.min(this.item.next_approver, num)
      }
    },
    clearApprover(i) {
      this.item['approval_date_' + i] = null
      this.item['approval_person_' + i] = null
    },
    clearApproverRole(i) {
      this.item['approver_' + i] = null
    },
    setApprovers() {
      if (this.item.status != 'Draft' && this.item.status != 'Feedback') {
        return
      }
      if (!this.item.type) {
        return
      }
      if (!this.currentUser) {
        return
      }

      if(this.sortalysContract || (this.item.type && ['SD_KUKO', 'CNS_KUKO', 'IMMUNO_KUKO', 'ONCO_KUKO', 'HOSP_KUKO'].includes(this.item.type))) {
        (this.item.contract_year >= 2025 || (this.item.type && this.item.type.endsWith('_KUKO'))) ? this.setApprover(1, 'Channel Head') : this.setApprover(1, 'FLM')
        var approverCount = 2
        for (var i = approverCount; i <= 6; i++) {
          this.clearApprover(i)
          this.clearApproverRole(i)
        }
      } else if(this.apoOtcContract || (this.item.type && this.item.type === 'APO_KUKO')) {
        (this.item.contract_year >= 2025 || (this.item.type && this.item.type.endsWith('_KUKO'))) ? this.setApprover(1, 'Channel Head') : this.setApprover(1, 'FLM')

        if(this.apoOtcContract && this.displayBusinessCase() === true) {
          this.item.contract_year >= 2025 ? this.setApprover(2, 'BU Head Retail') : this.setApprover(2, 'Channel Head')
        } else {
          this.setApprover(2, null)
        }

        var approverCount = 3
        for (var i = approverCount; i <= 6; i++) {
          this.clearApprover(i)
          this.clearApproverRole(i)
        }

        
      } else {
        var investZeroError = false
        if(this.item.turnover <= 0 || this.item.turnover_expectation <= 0 || this.item.marketing_activities_maximum <= 0 || this.item.marketing_activities_percentage <= 0) {
          investZeroError = true
          this.item.deviation_outside_margin = null
        }

        // No deviation if plandata null
        if(this.planData === null) {
          this.item.deviation_outside_margin = null
        }

        if((this.item.sales_line && this.item.sales_line.automatic_approval_allowed === true) && this.planData !== null) {
          if((this.plan_turnover_expectation_condition === true || this.plan_invest_condition === true ||  this.plan_discount_condition === true) &&
            (this.plan_turnover_outside_range !== true && this.plan_turnover_expectation_outside_range !== true && this.plan_invest_outside_range !== true && this.plan_discount_outside_range !== true)
          ) {
            this.item.deviation_outside_margin = 0
          }

          if((this.plan_turnover_expectation_condition === true || this.plan_invest_condition === true ||  this.plan_discount_condition === true) &&
            (this.plan_turnover_outside_range === true || this.plan_turnover_expectation_outside_range === true || this.plan_invest_outside_range == true || this.plan_discount_outside_range == true)
          ) {
            this.item.deviation_outside_margin = 1
          }

        }

        if((this.displayBusinessCase() && this.item.marketing_activities_maximum > 0 && this.item.marketing_activities_percentage > 0) || (investZeroError === false && (this.displayBusinessCase() || this.item.cap_exceeded || this.planData === null || (this.item.sales_line && this.item.sales_line.automatic_approval_allowed === false)) ||
          (!this.displayBusinessCase() && !this.item.cap_exceeded && (this.item.sales_line && this.item.sales_line.automatic_approval_allowed === true) && this.item.plan_deviation_skip_approval === false && this.planData !== null &&
            ((this.plan_turnover_outside_range === true) || (this.plan_turnover_expectation_condition === true) || (this.plan_invest_condition === true) || (this.plan_discount_condition === true)))
        )) {

          var currentFlmUserExist = false
          if(this.currentUser.approval_roles.data && Object.keys(this.currentUser.approval_roles.data).length) {
            if(this.item.contract_year >= 2025) {
              var currentFlmUser = this.currentUser.approval_roles.data.filter((role) => {
                return role.approval_role_type === this.item.type && role.approval_role === 'Channel Head'
              })
            } else {
              var currentFlmUser = this.currentUser.approval_roles.data.filter((role) => {
                return role.approval_role_type === this.item.type && ( role.approval_role === 'FLM' || role.approval_role === 'FLM1' || role.approval_role === 'FLM2')
              })
            }

            if(currentFlmUser && Object.keys(currentFlmUser).length === 0) {
              this.item.contract_year >= 2025 ? this.setApprover(1, 'Channel Head') : this.setApprover(1, this.currentUser.flm.data.flm_role)
            } else {
              currentFlmUserExist = true
            }
          } else {
            this.item.contract_year >= 2025 ? this.setApprover(1, 'Channel Head') : this.setApprover(1, this.currentUser.flm.data.flm_role)
          }

          if(currentFlmUserExist) {
            this.item.contract_year >= 2025 ? this.setApprover(1, 'BU Head Retail') : this.setApprover(1, 'Channel Head')
          } else {
            if (this.item.marketing_activities_maximum > this.item.invest_max || this.item.marketing_activities_maximum >= 100_000 || this.displayBusinessCase()) {
              this.item.contract_year >= 2025 ? this.setApprover(2, 'BU Head Retail') : this.setApprover(2, 'Channel Head')
            }
            else {
              this.setApprover(2, null)
            }
          }

          if(currentFlmUserExist) {
            if (this.item.marketing_activities_maximum >= 100_000 || this.displayBusinessCase()) {
              this.setApprover(2, 'CFO')
              this.setApprover(3, null)
            } else {
              this.setApprover(2, null)
            }
          } else {
            if (this.item.marketing_activities_maximum >= 100_000 || this.displayBusinessCase()) {
              this.setApprover(3, 'CFO')
            }
            else {
              this.setApprover(3, null)
            }
          }
        } else {
          var approvers = [1,2,3,4,5,6];
          for(var i=1; i<=approvers.length; i++) {
            this.setApprover(i, null)
          }

          if(investZeroError === false && this.item.plan_deviation_skip_approval === false) {
            this.item.deviation_outside_margin = null
          }
        }
      }

      this.$forceUpdate()
    },
    setMasterAddress () {
      this.addressMode = 'master'
      // only SD and sortalys contracts can have multiple contracts for a single practice
      this.showAddressModeCheckbox = this.item.type == 'SD' || this.sortalysContract
      this.$refs.addressSearch.showAddressSearchModal(this)
    },
    setTurnoverInvest () {
      var url = `/api/sandoz/sales_lines?filter[sales_line]=${this.item.type}`
      axios
        .get(url)
        .then((response) => {
          if(response.data.data && '0' in response.data.data) {

            this.$set(this.item, 'sales_line', response.data.data[0])
            var maximumInvest = response.data.data[0].maximum_invest
            if(maximumInvest) {
              this.item.invest_turnover = parseFloat(this.getPlanDataTurnoverActual() * maximumInvest).toFixed(2)
              this.item.invest_turnover_percentage = maximumInvest
            } else {
              this.item.invest_turnover = null
              this.item.invest_turnover_percentage = null
            }
            this.$nextTick(() => {
              this.calculatePlanTurnOver()
              this.calculatePlanTurnOverExpectation()
              this.calculatePlanTargetInvest()
              this.calculatePlanTargetDiscount()
            })
          }


        })
    },
    setTurnoverExpectation () {
      var url = `/api/sandoz/sales_lines?filter[sales_line]=${this.item.type}`
      axios
        .get(url)
        .then((response) => {
          if(response.data.data && '0' in response.data.data) {
            this.$set(this.item, 'sales_line', response.data.data[0])
            let maximumInvestExpectation = response.data.data[0].maximum_invest_expectation
            if(maximumInvestExpectation) {
              this.item.invest_growth = parseFloat(maximumInvestExpectation).toFixed(2)
              this.item.invest_turnover_forecast = parseFloat(this.item.growth_forecast * maximumInvestExpectation).toFixed(2)
            } else {
              this.item.invest_growth = null
              this.item.invest_turnover_forecast = null
            }

            this.$nextTick(() => {
              this.calculatePlanTurnOver()
              this.calculatePlanTurnOverExpectation()
              this.calculatePlanTargetInvest()
              this.calculatePlanTargetDiscount()
            })
          }
        })
    },
    setWithoutWatcher(propertyName, value) {
      if (this.watcherWorking || !this.loaded) {
        return
      }
      this.watcherWorking = true
      this.item[propertyName] = value
      this.$nextTick(() => {
        this.watcherWorking = false
      })
    },
    setWholesaler (address, owningComponent) {
      if (!address.org_wholesalers) {
        return
      }
      let wholesalers = address.org_wholesalers.trim().split(';').map(i => i.trim())

      owningComponent.item.wholesaler_1_id = null
      owningComponent.item.wholesaler_2_id = null
      owningComponent.item.wholesaler_3_id = null
      owningComponent.item.wholesaler_4_id = null
      owningComponent.item.wholesaler_5_id = null

      wholesalers.forEach((wholesaler, wholesalerIndex) => {
        let wholesalerSelectValues = this.wholesalerArray.filter(e => e.text === wholesaler)
        if (wholesalerSelectValues.length > 0) {
          let wholesalerSelectId = wholesalerSelectValues[0].value
          let wholesalerFieldIndex = wholesalerIndex + 1
          owningComponent.item[`wholesaler_${wholesalerFieldIndex}_id`] = wholesalerSelectId
        }
      })
    },
    addressSelected (addressEvent) {
      let address = addressEvent.address
      let multipleContractsPerPractice = addressEvent.multipleContractsPerPractice
      let owningComponent = addressEvent.owningComponent
      let owningComponentData = owningComponent.$data

      // set wholesalers
      this.setWholesaler(address, owningComponent)

      // set external id
      let externalId = multipleContractsPerPractice ? address.external_id : address.org_external_id

      switch (this.addressMode) {
        case 'master':
          owningComponentData.item.customer_external_id = externalId
          owningComponentData.item.kuko_link = null
          owningComponentData.item.kuko_id = null
          owningComponentData.item.kuko_status = null

          // set bank data
          // owningComponentData.item.vat = !!address.org_vat ? 'x': null
          owningComponentData.item.vat_number = address.org_vat
          owningComponentData.item.bank_name = address.org_bank_name
          owningComponentData.item.bank_address = address.org_bank_address
          owningComponentData.item.accountholder_name = address.org_bank_account
          owningComponentData.item.accountholder_address = address.org_bank_account_address
          owningComponentData.item.iban_no = address.org_iban

          this.item.language = address.language
          this.loadKukoDiscount()
          this.loadplanData()
          // set buying group
          if(address.buying_group && Object.keys(address.buying_group).length > 0){
            this.item.buying_group_code_when_uploaded = address.buying_group.buying_group_code
            this.item.customer_group = address.buying_group.buying_group
          } else {
            this.item.customer_group = null
            this.item.buying_group_code_when_uploaded = null
          }
          this.loadBuyingGroupLinks()

          this.setTurnoverInvest()
          let masterAddressData = {
            del_address: 1,
            address_type: 'master',
            company_name: address.org_full_name,
            street: address.org_street,
            zip: address.org_zip_code,
            city: address.org_city,
            customer_external_id: externalId,
            customer_external_id_hcp: address.external_id,
            customer_size: address.org_pharmacy_classification,
            default_customer_size: address.org_pharmacy_classification
          }

          let firstAddress = owningComponentData.item.addresses.length == 0

          if (owningComponentData.item.addresses.length > 0) {
            owningComponentData.item.addresses[0] = masterAddressData
          } else {
            owningComponentData.item.addresses.push(masterAddressData)
          }

          // always add a delivery address as well
          let deliveryAddress = {
            del_address: owningComponentData.item.addresses.length + 1,
            address_type: 'delivery',
            company_name: address.org_full_name,
            street: address.org_street,
            zip: address.org_zip_code,
            city: address.org_city,
            customer_external_id: externalId,
            customer_external_id_hcp: address.external_id,
            customer_size: address.org_pharmacy_classification,
            default_customer_size: address.org_pharmacy_classification,
            items: []
          }
          if (firstAddress) {
            owningComponentData.item.addresses.push(deliveryAddress)
            this.addItemsToAddresses(false)
          }

          break
        case 'delivery':
          owningComponentData.item.addresses.push({
            del_address: owningComponentData.item.addresses.length + 1,
            address_type: 'delivery',
            company_name: address.org_full_name,
            street: address.org_street,
            zip: address.org_zip_code,
            city: address.org_city,
            customer_external_id: externalId,
            customer_external_id_hcp: address.external_id,
            customer_size: address.org_pharmacy_classification,
            default_customer_size: address.org_pharmacy_classification,
            items: []
          })
          this.addItemsToAddresses(false)
          this.setContractDateToItems()
          break
      }
    },
    setCustomerSize (address, index) {
      if(address.default_customer_size === 'Klein') {
        this.customerSizes[index] = [
          { value: '', text: '' },
          { value: 'Klein', text: this.$i18n.t('sandoz.small') }
        ]

        this.heimCustomerSizes[index] = [
          { value: '', text: '' }
        ]
      } else if(address.default_customer_size === 'Mittel') {
        this.customerSizes[index] = [
          { value: '', text: '' },
          { value: 'Mittel', text: this.$i18n.t('sandoz.medium') }
        ]

        this.heimCustomerSizes[index] = [
          { value: '', text: '' },
          { value: 'Klein', text: this.$i18n.t('sandoz.small') },
          { value: 'Mittel', text: this.$i18n.t('sandoz.medium') }
        ]
      } else if(address.default_customer_size === 'Gross') {
        this.customerSizes[index] = [
          { value: '', text: '' },
          { value: 'Mittel', text: this.$i18n.t('sandoz.medium') },
          { value: 'Gross', text: this.$i18n.t('sandoz.big') }
        ]

        this.heimCustomerSizes[index] = [
          { value: '', text: '' },
          { value: 'Klein', text: this.$i18n.t('sandoz.small') },
          { value: 'Mittel', text: this.$i18n.t('sandoz.medium') },
          { value: 'Gross', text: this.$i18n.t('sandoz.big') }
        ]
      } else {
        this.customerSizes[index] = [
          { value: '', text: '' },
          { value: 'Mittel', text: this.$i18n.t('sandoz.medium') },
          { value: 'Gross', text: this.$i18n.t('sandoz.big') },
          { value: 'Sehr gross', text: this.$i18n.t('sandoz.very_big') }
        ]

        this.heimCustomerSizes[index] = [
          { value: '', text: '' },
          { value: 'Klein', text: this.$i18n.t('sandoz.small') },
          { value: 'Mittel', text: this.$i18n.t('sandoz.medium') },
          { value: 'Gross', text: this.$i18n.t('sandoz.big') },
          { value: 'Sehr gross', text: this.$i18n.t('sandoz.very_big') }
        ]
      }
    },
    setDefaultPrice() {
      var _self = this
      _self.$nextTick(function (){
        if(_self.item.addresses) {
          _self.item.addresses.forEach(function (address) {
            if(address.address_type !== 'delivery') {
              return false
            }

            if(address.items.length) {
              address.items.forEach(function (item) {
                item.price = item.loaded_price ? Math.round(item.loaded_price): null
                if (item.children && Object.keys(item.children).length) {
                  item.children.forEach(function (subItem){
                    subItem.price = subItem.loaded_price ? Math.round(subItem.loaded_price): null

                    if (subItem.children && Object.keys(subItem.children).length) {
                      subItem.children.forEach(function (childItem) {
                        childItem.price = childItem.loaded_price ? Math.round(childItem.loaded_price): null
                      })
                    }
                  })
                }
              })
            }
          })
        }
      })
    },
    setContractDateToItems() {
      const self = this
      const startDate = moment(self.item.contract_start)
      const expiredDate = moment(self.item.contract_expiration)

      let date = null
      let startMonth = null
      let startYear = null
      let endDate = null
      let endMonth = null
      let endYear = null
      if (startDate.isValid()) {
        date = startDate.date()
        startMonth = startDate.month() + 1
        startYear = startDate.year()
      }

      if (expiredDate.isValid()) {
        endDate = expiredDate.date()
        endMonth = expiredDate.month() + 1
        endYear = expiredDate.year()
      }

      startMonth = (startMonth < 10 ? '0' + startMonth : startMonth).toLocaleString()
      endMonth = (endMonth < 10 ? '0' + endMonth : endMonth).toLocaleString()

      if(self.item.addresses) {
        self.item.addresses.forEach(function (address, index) {
          if(address.address_type !== 'delivery') {
            return false
          }

          if(address.items) {
            address.items.forEach(function (line) {
              if(line.children) {
                line.children.forEach(function (subLine) {
                  if(subLine.children) {
                    subLine.children.forEach(function (childLine) {
                      childLine.valid_from_month = startYear != childLine.valid_from_year ? 1 : (childLine.valid_from_month ? (childLine.valid_from_changed ? childLine.valid_from_month : (childLine.id && !childLine.valid_from_changed ? childLine.valid_from_month: startMonth)) : startMonth)
                      childLine.valid_from_year = startYear != childLine.valid_from_year ? startYear : childLine.valid_from_year

                      childLine.valid_to_month = endYear != childLine.valid_to_year ? 12 : (childLine.valid_to_month ? (childLine.valid_to_changed ? childLine.valid_to_month : (childLine.id && !childLine.valid_to_changed ? childLine.valid_to_month: endMonth)) : endMonth)
                      childLine.valid_to_year = endYear != childLine.valid_to_year ? startYear : childLine.valid_to_year

                      self.$nextTick(function () {
                        if (self.$refs.contractItem) {
                          self.$refs.contractItem.setPrice(childLine, index)
                          self.$refs.contractItem.setHighLighter(childLine)
                        }
                      })
                    })
                  }

                  subLine.valid_from_month = startYear != subLine.valid_from_year ? 1 : (subLine.valid_from_month ? (subLine.valid_from_changed ? subLine.valid_from_month : (subLine.id && !subLine.valid_from_changed ? subLine.valid_from_month: startMonth)) : startMonth)
                  subLine.valid_from_year = startYear != subLine.valid_from_year ? startYear : subLine.valid_from_year

                  subLine.valid_to_month = endYear != subLine.valid_to_year ? 12 : (subLine.valid_to_month ? (subLine.valid_to_changed ? subLine.valid_to_month : (subLine.id && !subLine.valid_to_changed ? subLine.valid_to_month: endMonth)) : endMonth)
                  subLine.valid_to_year = endYear != subLine.valid_to_year ? startYear : subLine.valid_to_year

                  self.$nextTick(function () {
                    if (self.$refs.contractItem) {
                      self.$refs.contractItem.setPrice(subLine, index)
                      self.$refs.contractItem.setHighLighter(subLine)
                    }
                  })
                })
              }

              line.valid_from_month = startYear != line.valid_from_year ? 1 : (line.valid_from_month ? (line.valid_from_changed ? line.valid_from_month : (line.id && !line.valid_from_changed ? line.valid_from_month: startMonth)) : startMonth)
              line.valid_from_year = startYear != line.valid_from_year ? startYear : line.valid_from_year

              line.valid_to_month = endYear != line.valid_to_year ? 12 : (line.valid_to_month ? (line.valid_to_changed ? line.valid_to_month : (line.id && !line.valid_to_changed ? line.valid_to_month: endMonth)) : endMonth)
              line.valid_to_year = endYear != line.valid_to_year ? startYear : line.valid_to_year
              self.$nextTick(function () {
                if(!self.saving && self.$refs.contractItem) {
                  self.$refs.contractItem.setPrice(line, index)
                }

                if (self.$refs.contractItem) {
                  self.$refs.contractItem.setHighLighter(line)
                }
              })
            })
          }
        })
      }
    },
    getProductPrice(itm) {
      const self = this
      let price = null
      let addressKey = null
      if( self.addressIndex === 'all') {
        let addrFound = false
        self.item.addresses.forEach(function (address, key) {
          if (address.address_type === 'delivery' && !addrFound) {
            addressKey = key
            addrFound = true
          }
        })
      }
      const address = self.item.addresses[self.addressIndex === 'all' ? addressKey : self.addressIndex]
      if (itm.base_price && Object.keys(itm.base_price).length) {
        itm.base_price.forEach(function (p) {
          if (p.sales_line_price_category && Object.keys(p.sales_line_price_category).length) {
            if (p.sales_line_price_category.category_type === 'classification') {
              if (p.sales_line_price_category.price_category === address.customer_size) {
                price = p.price ? p.price: null
                return false
              }
            } else if (p.sales_line_price_category.category_type === 'fte') {
              if (p.price && address.fte) {
                price = p.price * address.fte
              }
              return false
            } else if (p.sales_line_price_category.category_type === 'fixed') {
              price = p.price ? p.price: null
              return false
            }
          }
        })
      }
      return price
    },
    addPreviousContract (contract) {
      this.item.previous_contract = contract.id
      this.item.previous = contract
      this.$refs.addPreviousContractModel.hide()
    },
    setPreviousContract (fromNewCustomer = false) {
      if(this.item.customer_external_id !== null && this.item.contract_year !== '' && this.item.type !== null) {
        var params = {
          customer_external_id: this.item.customer_external_id,
          contract_year: this.item.contract_year,
          type: this.item.type
        }
        let url = '/api/sandoz/ice-peak/contracts/get-previous-contract';
        axios.post(url, params)
        .then((response) => {
          const self = this
          let previousContract = response.data.previousContract
          if(previousContract) {
            self.item.previous_contract = previousContract.id
            self.item.previous = previousContract
            if(!fromNewCustomer) {
              self.item.new_customer = null
            }
          } else {
            self.item.previous_contract = null
            self.item.previous = null
            if(!fromNewCustomer) {
              self.item.new_customer = 'x'
            }
          }
        })
      }
    },
    addItemsToAddresses(reset = true){
      const _self = this
      this.$nextTick(function (){
        if(_self.item.addresses) {
          _self.item.addresses.forEach(function (address, index) {
            if(address.address_type !== 'delivery') {
              return false
            }

            _self.setCustomerSize (address, index)
            const isDraftOrNew = _self.$route.params.id === 'new' || (_self.item && (_self.item.status === 'Draft' || _self.item.status === 'Feedback'))
            if((reset && isDraftOrNew) || _self.$route.params.id === 'new') {
              _self.item.addresses[index].items = []
            }

            if (!address.items.length) {
              _self.addItemsToAddress (index, reset)
            }

            var sortOrder = 1
            if(address.items.length && _self.$route.params.id !== 'new') {
              address.items.forEach(function (item) {
                const itemPrice = _self.addItemPrice(item, index)
                const price = _self.$refs.contractItem ? _self.$refs.contractItem.calculatePrice(item, index) : {price: null, price_changes: null}

                item.item_price = itemPrice.price
                item.price = price.price
                item.price_changes = price.price_changes
                item.sort_order = sortOrder
                sortOrder++

                if (_self.$refs.contractItem) {
                  _self.$refs.contractItem.setHighLighter(item)
                }
                if (item.children && Object.keys(item.children).length) {
                  item.children.sort((a, b) => a.sort_order - b.sort_order).forEach(function (subItem){
                    const subItemPrice = _self.addItemPrice(subItem, index)
                    const subPrice = _self.$refs.contractItem ? _self.$refs.contractItem.calculatePrice(subItem, index) : {price: null, price_changes: null}

                    subItem.item_price = subItemPrice.price
                    subItem.price = subPrice.price
                    subItem.price_changes = subPrice.price_changes
                    subItem.sort_order = sortOrder
                    sortOrder++

                    if (_self.$refs.contractItem) {
                      _self.$refs.contractItem.setHighLighter(subItem)
                    }
                    if (subItem.children && Object.keys(subItem.children).length) {
                      subItem.children.sort((a, b) => a.sort_order - b.sort_order).forEach(function (childItem) {
                        const childItemPrice = _self.addItemPrice(childItem, index)
                        const childPrice = _self.$refs.contractItem ? _self.$refs.contractItem.calculatePrice(childItem, index) : {price: null, price_changes: null}

                        childItem.item_price = childItemPrice.price
                        childItem.price = childPrice.price
                        childItem.price_changes = childPrice.price_changes
                        childItem.sort_order = sortOrder
                        sortOrder++

                        if (_self.$refs.contractItem) {
                          _self.$refs.contractItem.setHighLighter(childItem)
                        }
                      })
                    }
                  })
                }
              })
            }
          })
        }
      })
    },
    addItemsToAddress (index) {
      const _self = this
      if (!this.item.type) {
        return
      }

      if(_self.addItemController) {
        _self.addItemController.abort()
      }
      _self.addItemController = new AbortController()
      let url = '/api/sandoz/ice-peak/items?c_type='+_self.item.type+'&c_start='+_self.item.contract_start+'&c_end='+_self.item.contract_expiration+'&c_lang='+_self.item.language+'&c_year='+_self.item.contract_year
      axios
        .get(url, {signal: _self.addItemController.signal})
        .then((response) => {
          var sortOrder = 1
          response.data.forEach(function (item){
            const itemPrice = _self.addItemPrice(item, index)
            const price = _self.$refs.contractItem ? _self.$refs.contractItem.calculatePrice(item, index) : {price: null, price_changes: null}

            item.item_price = itemPrice.price
            item.price = price.price
            item.price_changes = price.price_changes
            item.sort_order = sortOrder
            sortOrder++

            if (_self.$refs.contractItem) {
              _self.$refs.contractItem.setHighLighter(item)
            }
            if (item.children && Object.keys(item.children).length) {
              item.children.sort((a, b) => a.sort_order - b.sort_order).forEach(function (subItem){
                const subItemPrice = _self.addItemPrice(subItem, index)
                const subPrice = _self.$refs.contractItem ? _self.$refs.contractItem.calculatePrice(subItem, index) : {price: null, price_changes: null}

                subItem.item_price = subItemPrice.price
                subItem.price = subPrice.price
                subItem.price_changes = subPrice.price_changes
                subItem.sort_order = sortOrder
                sortOrder++

                if (_self.$refs.contractItem) {
                  _self.$refs.contractItem.setHighLighter(subItem)
                }
                if (subItem.children && Object.keys(subItem.children).length) {
                  subItem.children.sort((a, b) => a.sort_order - b.sort_order).forEach(function (childItem) {
                    const childItemPrice = _self.addItemPrice(childItem, index)
                    const childPrice = _self.$refs.contractItem ? _self.$refs.contractItem.calculatePrice(childItem, index) : {price: null, price_changes: null}

                    childItem.item_price = childItemPrice.price
                    childItem.price = childPrice.price
                    childItem.price_changes = childPrice.price_changes
                    childItem.sort_order = sortOrder
                    sortOrder++

                    if (_self.$refs.contractItem) {
                      _self.$refs.contractItem.setHighLighter(childItem)
                    }
                  })
                }
              })
            }

            _self.item.addresses[index].items.push(item)
          })

          _self.$nextTick(() => {
            if (_self.$refs.contractItem) {
              _self.$refs.contractItem.setQuantityChildParent()
              _self.$refs.contractItem.setQuantityToChildSpecialLoad()
            }

            // Clone flow: automatically copy quantities from source contract
            if (_self.$route.query.from && _self.$route.params.id === 'new' && _self.cloneSourceContract) {
              _self.copyQuantitiesFromSource()
              if (_self.$refs.contractItem) {
                _self.$refs.contractItem.setQuantityChildParent()
                _self.$refs.contractItem.setQuantityToChildSpecialLoad()
                _self.$refs.contractItem.$forceUpdate()
              }
            }
          })
          _self.addItemsToAddressFlag = false
          _self.addItemsToAddressFlagIndex = null
        }).catch(error => {
          if (axios.isCancel(error)) {
            // request was cancelled
            console.log(error)
          }
      });
    },
    addItemPrice(itm, index = -1){
      const self = this
      let itemPrice = null
      let priceChanges = {}
      const address = self.item.addresses[index === -1 ? self.addressIndex: index]
      if (itm.base_price && Object.keys(itm.base_price).length) {
        itm.base_price.forEach(function (p) {
          if (p.sales_line_price_category && Object.keys(p.sales_line_price_category).length) {
            if (p.sales_line_price_category.category_type === 'classification') {
              if (p.sales_line_price_category.price_category === address.customer_size) {
                itemPrice = p.price ? p.price: null
                priceChanges = p.price_changes
                return false
              }
            } else if (p.sales_line_price_category.category_type === 'fte') {
              if (p.price && address.fte) {
                if(p.fixed_independent_fte) {
                  itemPrice = p.price
                } else {
                  itemPrice = p.price * address.fte
                }
              }
              priceChanges = p.price_changes
              return false
            } else if (p.sales_line_price_category.category_type === 'fixed') {
              itemPrice = p.price ? p.price: null
              priceChanges = p.price_changes
              return false
            }
          } else if(p.price_changes) {
            priceChanges = p.price_changes
            return false
          }
        })
      }

      return {'price': itemPrice, 'price_changes': priceChanges?priceChanges:{}}
    },
    pdfContract() {
      this.saving = true
      this.$root.$loading.start()
      let delAddress = null
      this.item.addresses.forEach(function (address, key) {
        if (address.address_type === 'master' && delAddress === null) {
          delAddress = address
        }
      })

      let documentName = this.item.contract_no;
      if(this.item.contract_version !== null) {
        documentName += '-'+this.item.contract_version
      }else {
        documentName += '-1';
      }

      if(delAddress) {
        documentName += '-'+delAddress.company_name+' - '+delAddress.city
      }

      axios.post('/api/sandoz/generate-pdf2', {id:this.$route.params.id}, { responseType: 'arraybuffer' })
        .then((response) => {
          require('downloadjs')(
              response.data,
              documentName+'.pdf',
              'application/pdf'
          )
          this.$root.$loading.finish()
          this.saving = false
        }).catch((error) => {
          this.$root.$loading.finish()
          this.saving = false
          console.log(error)
        })
    },
    confirmWithUser() {
      const self = this
      var diffObject = diff(self.itemOld, self.item)
      delete diffObject['cap_exceeded']
      delete diffObject['sales_line']
      console.log("diffObject", diffObject)
      if((self.item.status === 'Draft' || self.item.status === 'Feedback') && ( self.item.save_before_pdf_download || (diffObject && Object.keys(diffObject).length))) {
        self.$bvModal.msgBoxConfirm('Some changes are not saved!', {
            title: 'Save changes',
            size: 'md',
            buttonSize: 'sm',
            okVariant: 'primary',
            okTitle: 'Save & Continue',
            cancelTitle: 'Cancel',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
          })
        .then(value => {
          if(value) {
            self.downloadPDF = true
            self.item.is_pdf_download = true
            self.save()
          }
        })
        .catch(err => {
          console.log('error', err)
          // An error occurred
        })
      } else {
        self.pdfContract()
      }
    },
    showDuplicateContract () {
      const routeData = this.$router.resolve({ path: '/sandoz/ice_peak/contracts/' + this.showContract })
      window.open(routeData.href, '_blank')
    },
    updateEventCheckboxes(address, addrIndex) {
      if(address.items.length) {
        const self = this
        address.items.forEach(function (line, index) {
          if(line.type === 'service' && line.sandoz_academy_event && self.$refs.contractItem && !self.$refs.contractItem.isReadonly(line, 'yearly')) {
            line.delivery.yearly.quantity = address.eventHeaderCheckbox ? 1 : 0

            if (self.$refs.contractItem) {
              self.$refs.contractItem.setQuantityToChild(line, 'q1', addrIndex)
              self.$refs.contractItem.setPrice(line, addrIndex, 'yearly')
            }

            if (line.children && Object.keys(line.children).length) {
              line.children.forEach(function (subLine, subLineIndex) {
                if(subLine.type === 'service' && subLine.sandoz_academy_event && self.$refs.contractItem && !self.$refs.contractItem.isReadonly(subLine, 'yearly')) {

                  subLine.delivery.yearly.quantity = address.eventHeaderCheckbox ? 1 : 0
                  if (self.$refs.contractItem) {
                    self.$refs.contractItem.setQuantityToParent(line, subLine, 'yearly', addrIndex)
                    self.$refs.contractItem.setQuantityToChild(subLine, 'yearly', subLineIndex)
                    self.$refs.contractItem.setBoxQuantity(line, 'yearly', subLine.box_or_gadget, addrIndex)
                  }

                  if (subLine.children && Object.keys(subLine.children).length) {
                    subLine.children.forEach(function (childLine, childLineIndex) {
                      if(childLine.type === 'service' && childLine.sandoz_academy_event && self.$refs.contractItem && !self.$refs.contractItem.isReadonly(childLine, 'yearly')) {

                        childLine.delivery.yearly.quantity = address.eventHeaderCheckbox ? 1 : 0
                        if (self.$refs.contractItem) {
                          self.$refs.contractItem.setQuantityToParent(subLine, childLine, 'yearly', addrIndex)
                          self.$refs.contractItem.setBoxQuantity(line, 'yearly', childLine.box_or_gadget, addrIndex)
                        }
                      }
                    })
                  }
                }
              })
            }
          }
        })
      }
    },
    checkLineChildren(line) {

      if(line.children && Object.keys(line.children).length)
      {
        return true
      }
      return false
    },
    displayBusinessCase() {
      let marketing_activities_maximum = (this.item.marketing_activities_maximum === null || this.item.marketing_activities_maximum === 0) ? 0 : this.item.marketing_activities_maximum
      let discount = (this.item.discount === null || this.item.discount === 0) ? 0 : this.item.discount
      let total = parseInt(marketing_activities_maximum) + parseInt(discount)
      let invest_max = (this.item.invest_max === null || this.item.invest_max === 0) ? 0 : this.item.invest_max
      let invest_turnover_expectation = (this.item.turnover_expectation === null || this.item.turnover_expectation === 0) ? 0 : this.item.turnover_expectation
      let marketing_activities_otc = (this.item.marketing_activities_otc === null || this.item.marketing_activities_otc === 0) ? 0 : this.item.marketing_activities_otc

      var percentageRatio = 0
      if(marketing_activities_otc > 0 && invest_turnover_expectation > 0){
        var percentageRatio = ((marketing_activities_otc)/invest_turnover_expectation).toFixed(2)
      }

      if(percentageRatio > 0){
        this.item.marketing_activities_otc_percentage = percentageRatio
        percentageRatio = percentageRatio * 100
      } else {
        this.item.marketing_activities_otc_percentage = null
      }

      if(this.item.type === 'APO_OTC' && (parseInt(total) > 60000) || percentageRatio > 600){
        return true
      }else if((this.item.type === 'APO' || this.item.type === 'BIOS_APO' || this.item.type === 'IMMUNO' || this.item.type === 'HEIM' || this.item.type === 'APO_KUKO' || this.item.type === 'IMMUNO_KUKO') && ( parseInt(invest_turnover_expectation) > 250_000 || (parseInt(total) > 0 && parseInt(total) > parseInt(invest_max)) || parseInt(total) > 100_000)){
        return true
      } else if((this.item.type === 'SD' || this.item.type === 'ONCO' || this.item.type === 'CNS' || this.item.type === 'SD_KUKO' || this.item.type === 'ONCO_KUKO' || this.item.type === 'CNS_KUKO') && ( parseInt(invest_turnover_expectation) > 150_000 || (parseInt(total) > 0 && parseInt(total) > parseInt(invest_max)) || parseInt(total) > 100_000)){
        return true
      }

      return false
    },
    isKukoContract() {
      return this.item.type && this.item.type.endsWith('_KUKO')
    },
    // The "Reason Businesscase" field doesn't apply to KUKO contract types, so we hide it
    // (and skip its required-validation) for them, while leaving displayBusinessCase() untouched
    // for the approval-routing logic that also relies on it.
    showBusinessCase() {
      return this.displayBusinessCase() && !this.isKukoContract()
    },
    loadKukoDiscount() {
      if(this.item.type && this.item.contract_year && this.item.customer_external_id && (this.item.status === 'Draft' || this.item.status === 'Feedback')) {
        let type = this.item.type
        if (type.endsWith('_KUKO')) {
            type = type.replace('_KUKO', '')
        }
        if (type.endsWith('_SORTALYS')) {
            type = type.replace('_SORTALYS', '')
        }
        if (type === 'HIGHSPEC') {
            type = 'High Specialty'
        }
        if (type === 'APO_OTC') {
            type = 'APO'
        }

        const self = this

        // Initialize originalKukos on first load
        if (!self.originalKukos) {
          self.originalKukos = (self.item.kukos || [])
            .filter(k => k && k.status !== 'Cancelled')
            .map(k => ({ id: k.id, status: k.status, discount_lower_100: k.discount_lower_100 }))
        }

        // As per requirements: if contract has an id (existing), ALWAYS preserve the DB-linked KUKOs.
        // If it's a new contract, originalKukos is empty, so this clears any stale selections on criteria change.
        const existingKukos = (self.originalKukos || [])
          .filter(k => k && k.status !== 'Cancelled')
          .map(k => ({ id: k.id, status: k.status, discount_lower_100: k.discount_lower_100 }))
        self.$set(self.item, 'kukos', existingKukos)

        const updateKukoFields = () => {
          const validKukos = self.item.kukos.filter(k => k.status !== 'Rejected' && k.status !== 'Cancelled')
          const sum = validKukos.reduce((total, kuko) => total + (parseInt(kuko.discount_lower_100) || 0), 0)
          self.item.discount = sum
          if (validKukos.length > 0) {
            self.$set(self.item, 'kuko_link', validKukos[0].id)
            self.$set(self.item, 'kuko_id', validKukos[0].id)
            self.item.kuko_status = validKukos[0].status
          } else {
            self.$set(self.item, 'kuko_link', null)
            self.$set(self.item, 'kuko_id', null)
            self.item.kuko_status = null
          }
        }

        let searchPromise = Promise.resolve()

        if (!self.item.id) {
          const searchUrl = `/api/kukos?external_id=${self.item.customer_external_id}&kuko_year=${self.item.contract_year}&channel=${type}&include_owned=1&per_page=100`
          searchPromise = axios.get(searchUrl).then((response) => {
            const kukoList = response.data.data || []
            kukoList.forEach((kukoData) => {
              if (kukoData && kukoData.status !== 'Cancelled') {
                if (!self.item.kukos.find(k => k.id === kukoData.id)) {
                  self.item.kukos.push({
                    id: kukoData.id,
                    status: kukoData.status,
                    discount_lower_100: kukoData.discount_lower_100
                  })
                }
              }
            })
          })
        }

        // Fetch fresh data for each KUKO currently in self.item.kukos (e.g. from original load)
        const pivotPromises = (self.item.kukos || []).map(k =>
          axios.get(`/api/kukos/${k.id}`).then((response) => {
            const kukoData = response.data.data ? response.data.data : response.data
            if (kukoData) {
              const existing = self.item.kukos.find(kk => kk.id === kukoData.id)
              if (existing) {
                existing.status = kukoData.status
                existing.discount_lower_100 = kukoData.discount_lower_100
              }
            }
          }).catch(() => {})
        )

        Promise.all([...pivotPromises, searchPromise]).then(() => {
          updateKukoFields()
        }).catch((err) => {
          console.error("Error loading KUKO discounts:", err)
        })
      }
    },
    checkIndeterminantCheckbox() {
      if(this.item.addresses) {
        const self = this

        var determError = false;
        self.determErrorID = []
        self.item.addresses.forEach(function (address, index) {
          if(address.address_type === 'delivery') {
            address.items.forEach(function (line, lineIndex) {
              if(line.type === 'marketing_activity' && line.contract_line_exist_attribute === 'indeterminate' && (line.exists_attribute_required || line.exist_value !== null) && (line.delivery && line.delivery['yearly'].quantity !== null || line.delivery['q1'].quantity !== null || line.delivery['q2'].quantity !== null || line.delivery['q3'].quantity !== null || line.delivery['q4'].quantity !== null)) {
                determError = true;
                self.determErrorID.push(address.id+'-'+line.product.id)
              }

              if(line.children && Object.keys(line.children).length) {
                line.children.forEach(function (subLine, subLineIndex) {

                  if(subLine.type === 'marketing_activity' && subLine.contract_line_exist_attribute === 'indeterminate' && (subLine.exists_attribute_required || subLine.exist_value !== null) && (subLine.delivery && subLine.delivery['yearly'].quantity !== null || subLine.delivery['q1'].quantity !== null || subLine.delivery['q2'].quantity !== null || subLine.delivery['q3'].quantity !== null || subLine.delivery['q4'].quantity !== null)) {
                    determError = true;
                    self.determErrorID.push(address.id+'-'+subLine.product.id)
                  }

                  if(subLine.children && Object.keys(subLine.children).length) {
                    subLine.children.forEach(function (childLine, childLineIndex) {
                      if(childLine.type === 'marketing_activity' && childLine.contract_line_exist_attribute === 'indeterminate' && (childLine.exists_attribute_required || childLine.exist_value !== null) && (childLine.delivery && childLine.delivery['yearly'].quantity !== null || childLine.delivery['q1'].quantity !== null || childLine.delivery['q2'].quantity !== null || childLine.delivery['q3'].quantity !== null || childLine.delivery['q4'].quantity !== null)) {
                        determError = true;
                        self.determErrorID.push(address.id+'-'+childLine.product.id)
                      }
                    })
                  }
                })
              }
            })
          }
        })

        return determError
      }
    },
    getWholesalers () {
      const self = this
      var url = `/api/wholesalers?page=1&per_page=9999&filter[hide_empty_dwh_name]=1&sortBy=dwh_name&sortByDirection=asc`
      axios
        .get(url)
        .then((response) => {
          self.wholesalerArray = [{value: 'null', text: ''}]
          if(response.data.data) {
            response.data.data.forEach(function(wholesaler) {
              self.wholesalerArray.push({value: wholesaler.id, text: wholesaler.dwh_name})
            })
          }
      })
    },
    setWholesalers (savedItem) {
      let saveWholesalers = ['1','2','3','4','5'];
      const self = this
      saveWholesalers.forEach(function (wh) {
        self.item['wholesaler_'+wh+'_id'] = savedItem['wholesaler_'+wh+'_id']
      })
    },
    setTitleItems () {
      if(this.item.language === 'DE') {
        this.titleItems = [
          { value: null, text: 'Partnertitel auswählen' },
          { value: 'Inhaber', text: 'Inhaber'},
          { value: 'Inhaberin', text: 'Inhaberin' },
          { value: 'Dr. med.', text: 'Dr. med.'},
          { value: 'Geschäftsführer', text: 'Geschäftsführer'},
          { value: 'Geschäftsführerin', text: 'Geschäftsführerin'},
          { value: 'FMH Allgemeine Innere Medizin', text: 'FMH Allgemeine Innere Medizin'}
        ]
      } else if(this.item.language === 'FR') {
        this.titleItems = [
          { value: null, text: 'Sélectionnez le titre du partenaire' },
          { value: 'Propriétaire', text: 'Propriétaire'},
          { value: 'Pharmacienne responsable', text: 'Pharmacienne responsable' },
          { value: 'Pharmacien responsable', text: 'Pharmacien responsable'},
          { value: 'Pharmacienne', text: 'Pharmacienne'},
          { value: 'Pharmacien', text: 'Pharmacien'},
          { value: 'Dr. med.', text: 'Dr. med.'}
        ]

      } else if(this.item.language === 'IT') {
        this.titleItems = [
          { value: null, text: 'Seleziona il titolo del partner' },
          { value: 'Gerente', text: 'Gerente'},
          { value: 'Proprietario', text: 'Proprietario' },
          { value: 'Proprietaria', text: 'Proprietaria'},
          { value: 'Dr. med.', text: 'Dr. med.'}
        ]
      }
    },
    setTitle (i) {
      this.item['contract_partner_'+i+'_title'] = this.item['contract_partner_'+i+'_title_dropdown']
    },
    changeContractDuration() {
      const startDate = moment(this.item.contract_start)
      const startYear = startDate.format('YYYY')
      if(startYear !== this.item.contract_year) {
        this.item.contract_start = this.item.contract_year + '-01-01'
        this.item.contract_expiration = this.item.contract_year + '-12-31'
      }
    },
    openKuko(kukoID) {
      if(kukoID !== '') {
        this.$router.push({ name:'sandoz.kuko.detail', params: {id:kukoID}})
      }
    },
    createKuko() {
      if (this.$route.params.id === 'new') {
        this.$refs.kukoSaveWarningModel.show()
        return
      }
      this.$nextTick(async function () {
        const contract = await axios.post(`/api/sandoz/ice-peak/contracts/search-addresses`, {
          q: this.item.customer_external_id
        }).then(response => {
          if ('0' in response.data.data) {
            return response.data.data[0]
          }
          return null
        })

        const route = this.$router.resolve({
          name: 'sandoz.kuko.detail', params: { id: 'new' }, query: {
            type: this.item.type,
            year: this.item.contract_year,
            external_id: this.item.customer_external_id,
            sap_id: contract ? contract.org_sap_id : null,
            sub_type: contract ? contract.org_sub_type : null,
            primary: contract ? contract.parent_full_name : null,
            company: contract ? contract.org_full_name : null,
            street: contract ? contract.org_street : null,
            city: contract ? contract.org_zip_code + " " + contract.org_city : null
          }
        })
        window.open(route.href)
      })
    },
    openCopyPreviousYearKuko() {
      if (this.$route.params.id === 'new') {
        window.alert(this.$t('sandoz.kuko_save_required_message'))
        return
      }
      if (!this.item.customer_external_id || !this.item.contract_year) {
        this.previousYearKukos = []
        this.$refs.previousYearKukoModal.show()
        return
      }
      // Same external ID, the previous year and the account category a KUKO created from this
      // contract would use (individual account, see createKuko).
      const previousYear = parseInt(this.item.contract_year, 10) - 1
      const url = `/api/kukos?filter[external_id]=${encodeURIComponent(this.item.customer_external_id)}&filter[kuko_year]=${previousYear}&filter[account_category]=individual_account&per_page=999`
      axios.get(url).then((response) => {
        this.previousYearKukos = response.data.data || []
        this.$refs.previousYearKukoModal.show()
      })
    },
    async copyPreviousYearKuko(kukoId) {
      if (this.copyingKuko) {
        return
      }
      this.copyingKuko = true
      try {
        let url = `/api/kukos/${kukoId}?include=user,approval_feedback_user,wholesalers,wholesalers.wholesaler,condition_product_groups,condition_product_groups.kuko_product_group,condition_products,condition_products.kuko_product,condition_special_products,condition_special_products.kuko_product,condition_product_rebates,condition_product_group_rebates,condition_special_product_rebates,approval_steps,approval_steps.trigger_notification,otc_product_attachments,special_order_attachments,customers`

        const { data: newObj } = await axios.get(url)

        delete newObj.id
        delete newObj.approval_steps
        delete newObj.approval_finished_notification_sent_at
        delete newObj.approval_stored_notification_sent_at
        delete newObj.contracts

        newObj.user_id = this.user.id

        let clearObjects = ['condition_product_groups', 'condition_products', 'wholesalers', 'condition_special_products', 'condition_product_rebates',
          'condition_special_product_rebates', 'condition_product_group_rebates', 'smart_selection_conditions', 'otc_product_attachments', 'special_order_attachments',
          'customers']

        clearObjects.forEach(o => {
          const records = newObj[o] || []
          records.forEach(r => {
            delete r.id
            delete r.kuko_id
          })
        })

        newObj.status = 'Draft'
        newObj.file_name = [...Array(30)].map(() => Math.random().toString(36)[2]).join('')

        let today = new Date()
        let month = (today.getMonth() + 1).toString().padStart(2, "0")
        let day = today.getDate().toString().padStart(2, "0")
        newObj.kuko_date = today.getFullYear() + '-' + month + '-' + day
        // The copy is for this contract's year, the source KUKO is from the previous year.
        newObj.kuko_year = this.item.contract_year

        // Refresh the customer address from the warehouse, same as createKuko does.
        if (newObj.account_category === 'individual_account' && newObj.external_id) {
          await this.fetchReplaceCustomerForKukoCopy(newObj)
        }

        const { data: newResponse } = await axios.get(`/api/kukos/new`)
        newObj.approval_steps = newResponse.approval_steps

        if (newObj.channel !== 'Market Access') {
          newObj.approval_steps = newObj.approval_steps.filter(step => step.approval_role !== 'Head of Market Access')
        } else {
          newObj.approval_steps = newObj.approval_steps.filter(step => step.approval_role !== 'Business')
        }

        const { data: finalResponse } = await axios.post(`/api/kukos/new`, newObj)

        this.$refs.previousYearKukoModal.hide()

        const href = this.$router.resolve({ name: 'sandoz.kuko.detail', params: { id: finalResponse.id } }).href
        window.open(href, '_blank')
      } finally {
        this.copyingKuko = false
      }
    },
    async fetchReplaceCustomerForKukoCopy(newObj) {
      try {
        const response = await axios.post(`/api/sandoz/ice-peak/contracts/search-addresses`, { q: newObj.external_id })
        const responseData = response.data
        if (responseData && responseData.data && responseData.data.length) {
          const address = responseData.data[0]
          newObj.sap_id = address.org_sap_id
          newObj.account_sub_type = address.org_sub_type
          newObj.primary_parent = address.parent_full_name
          newObj.address1 = address.org_full_name
          newObj.address2 = address.org_street
          newObj.address3 = address.org_zip_code + ' ' + address.org_city
        }
      } catch (error) {
        console.error(error)
      }
    },
    saveAndContinueKuko() {
      this.continueToKuko = true
      this.save()
      this.$refs.kukoSaveWarningModel.hide()
    },
    loadplanData() {
      if(this.item.contract_year && this.item.type && this.item.customer_external_id && (this.item.status === 'Draft' || this.item.status === 'Feedback')) {
        let url = '/api/loadplanData?type='+this.item.type+'&year='+this.item.contract_year+'&external_id='+this.item.customer_external_id
        axios
          .get(url)
          .then((response) => {
            var planData = response.data.planData
            this.planData = planData
            if(planData) {
              // if(planData.turnover_actual != null && planData.turnover_actual != 0) {
              //   this.item.plan_turnover_actual = parseInt(planData.turnover_actual)
              // } else
              this.item.plan_outlook = parseInt(planData.turnover_actual)
              if(planData.outlook != "" && planData.outlook != "0") {
                this.item.plan_turnover_actual = parseInt(planData.outlook)
              } else {
                this.item.plan_turnover_actual = null
              }

              this.item.plan_turnover_expectation = planData.turnover_expectation !== null ? this.calculatePriceBasedonDuration(parseInt(planData.turnover_expectation)) : null
              this.item.plan_target_invest = planData.target_invest !== null ? this.calculatePriceBasedonDuration(parseInt(planData.target_invest)) : null
              this.item.plan_turnover_actual = this.item.plan_turnover_actual !== null ? this.calculatePriceBasedonDuration(parseInt(this.item.plan_turnover_actual)) : null
              this.item.plan_target_discount = planData.target_discount !== null ? this.calculatePriceBasedonDuration(parseInt(planData.target_discount)) : null

              // set planned activity percentage
              if(this.item.plan_turnover_expectation !== 0 && this.item.plan_turnover_expectation !== null && this.item.plan_target_invest !== 0 && this.item.plan_target_invest !== null) {
                this.marketing_activities_percentage =  this.item.plan_target_invest / this.item.plan_turnover_expectation
              }

              if(this.$route.params.id === 'new' || parseInt(this.item.turnover_expectation) === 0) {
                this.item.turnover_expectation = parseInt(planData.turnover_expectation)
              }
              
              if((this.apoOtcContract === false && this.$route.params.id === 'new' && parseInt(this.item.marketing_activities_maximum) === 0)) {
                this.item.marketing_activities_maximum = parseInt(planData.target_invest)
              }

              if((this.apoOtcContract === true && ( Number.isNaN(this.item.marketing_activities_otc) || this.item.marketing_activities_otc === 0 || this.item.marketing_activities_otc === null))) {
                this.item.marketing_activities_otc = parseInt(planData.target_invest)
              }

              if(this.$route.params.id === 'new' || Number.isNaN(this.item.turnover) || isNaN(parseFloat(this.item.turnover)) || parseInt(this.item.turnover) === 0) {
                if(this.checkTurnOverReadonly()) {
                  this.item.turnover = this.item.plan_turnover_actual
                }
              }
            } else {
              this.item.plan_turnover_expectation = null
              this.item.plan_target_invest = null
              this.item.plan_target_discount =  null
              this.item.plan_turnover_actual = null
              this.marketing_activities_percentage = null
              this.item.deviation_outside_margin = null


              if(this.$route.params.id === 'new') {
                this.item.turnover_expectation = 0
                this.item.marketing_activities_maximum = 0
                this.item.marketing_activities_otc = 0
              }
            }

            this.$nextTick(() => {
              this.calculatePlanTurnOver()
              this.calculatePlanTurnOverExpectation()
              this.calculatePlanTargetInvest()
              this.calculatePlanTargetDiscount()
              this.compareMarketingActivityForOTC()
              this.compareTurnoverExpectationForOTC()
              this.setApprovers()
            })
          })
      }
    },
    calculatePlanTurnOver() {
      if(this.turnoverExpectionPercentageBaseline !== null && this.item.sales_line) {
        var deviation_min_growth =  this.item.sales_line.deviation_min_growth
        if(this.item.sales_line.deviation_min_growth !== null && this.item.sales_line.deviation_min_growth !== 0) {
          var deviation_min_growth = parseFloat(this.item.sales_line.deviation_min_growth*100).toFixed(2)
          var turnoverExpectationBase = parseFloat(this.turnoverExpectionPercentageBaseline.replace('%', '')).toFixed(2)
          if(parseFloat(turnoverExpectationBase) < parseFloat(deviation_min_growth)) {
            this.plan_turnover_outside_range = true
            return 'text-danger';
          } else {
            this.plan_turnover_outside_range = false
            return 'text-muted';
          }
        }
        return 'text-muted';
      }
    },
    calculatePlanTurnOverExpectation() {
      var planTurnOverExpectation = null
      if(this.item.plan_turnover_expectation !== 0 && this.item.plan_turnover_expectation !== null){
        planTurnOverExpectation = this.item.plan_turnover_expectation
      }

      var contractTurnOverExpectation = parseInt(this.item.turnover_expectation)

      if(contractTurnOverExpectation !== 0 && planTurnOverExpectation !== null && this.item.sales_line) {

        if(contractTurnOverExpectation < parseInt(planTurnOverExpectation)) {
          var rangePercentage = this.checkDifferenceAndGetPercDeviation(contractTurnOverExpectation)
          if(rangePercentage !== null && rangePercentage !== 0 && rangePercentage !== 0.00) {
            this.plan_turnover_expectation_condition = true
            var maxDeviationValue = parseInt(planTurnOverExpectation) - (parseInt(planTurnOverExpectation)*rangePercentage)
            if(parseFloat(contractTurnOverExpectation) < parseFloat(maxDeviationValue)) {
              this.item.plan_deviation_skip_approval = false
              this.plan_turnover_expectation_outside_range = true
              return 'text-danger';
            } else {
              this.plan_turnover_expectation_outside_range = null
              return 'text-muted';
            }
          }
        } else {
          this.plan_turnover_expectation_condition = false
          this.plan_turnover_expectation_outside_range = null
          return 'text-muted';
        }
      } else {
        this.plan_turnover_expectation_outside_range = null
      }
      return 'text-muted';
    },
    calculatePlanTargetInvest() {
      var planTargetInvest = null
      if(this.item.plan_target_invest !== 0 && this.item.plan_target_invest !== null){
        planTargetInvest = this.item.plan_target_invest
      }
      var contractTargetInvest = parseInt(this.item.marketing_activities_maximum)
      if(contractTargetInvest !== 0 && planTargetInvest !== null && this.item.sales_line) {
        if(contractTargetInvest > parseInt(planTargetInvest)) {
          var rangePercentage = this.checkDifferenceAndGetPercDeviation(contractTargetInvest)
          if(rangePercentage !== null && rangePercentage !== 0 && rangePercentage !== 0.00) {
            this.plan_invest_condition = true
            var maxDeviationValue = parseInt(planTargetInvest) + (parseInt(planTargetInvest)*rangePercentage)
            if(parseFloat(contractTargetInvest) > parseFloat(maxDeviationValue)) {
              this.item.plan_deviation_skip_approval = false
              this.plan_invest_outside_range = true
              return 'text-danger';
            } else {
              this.plan_invest_outside_range = null
              return 'text-muted';
            }
          }
        } else {
          this.plan_invest_condition = false
          this.plan_invest_outside_range = null
          return 'text-muted';
        }
      } else {
        this.plan_invest_outside_range = null
      }
      return 'text-muted';
    },
    calculatePlanTargetDiscount() {
      var planTargetDiscount = null
      if(this.item.plan_target_discount !== 0 && this.item.plan_target_discount !== null){
        planTargetDiscount = this.item.plan_target_discount
      }

      var contractTargetDiscount = parseInt(this.item.discount)
      if(contractTargetDiscount !== 0 && planTargetDiscount !== null && planTargetDiscount != 0.00 && this.item.sales_line) {
        if(contractTargetDiscount > parseInt(planTargetDiscount)) {
          var rangePercentage = this.checkDifferenceAndGetPercDeviation(contractTargetDiscount)
          if(rangePercentage !== null && rangePercentage !== 0 && rangePercentage !== 0.00) {
            this.plan_discount_condition = true
            var maxDeviationValue = parseInt(planTargetDiscount) + (parseInt(planTargetDiscount)*rangePercentage)
            if(parseFloat(contractTargetDiscount) > parseFloat(maxDeviationValue)) {
              this.item.plan_deviation_skip_approval = false
              this.plan_discount_outside_range = true
              return 'text-danger';
            } else {
              this.plan_discount_outside_range = null
              return 'text-muted';
            }
          }
        } else {
          this.plan_discount_condition = false
          this.plan_discount_outside_range = null
          return 'text-muted';
        }
      } else {
        this.plan_discount_outside_range = null
      }
      return 'text-muted';
    },
    formatDescription(value) {
      if(value) {
        return this.$options.filters.formatInteger(value);
      }
      return null
    },
    checkTurnOverReadonly() {
      var check = false
      if(this.readonly || (!Number.isNaN(this.item.plan_turnover_actual) && !isNaN(parseFloat(this.item.plan_turnover_actual)) && this.item.plan_turnover_actual !== 0 && this.item.plan_turnover_actual !== null)) {
        check = true
      }
      return check
    },
    calculatePriceBasedonDuration(val) {
      // if(val !== null && val !== 0 && val !== 0.00 && this.item && this.$route.params.id === 'new') {
      //   var contractStart = this.item.contract_start
      //   var contractExpiration = this.item.contract_expiration
      //   contractStart = contractStart === null ? 12 : parseInt(moment(contractStart).format('MM'))
      //   contractExpiration = contractExpiration === null ? 12 : parseInt(moment(contractExpiration).format('MM'))
      //   var durationVal = (val / 12) * ((contractExpiration - contractStart) + 1)
      //   return parseInt(durationVal)
      // }
      return val
    },
    checkDifferenceAndGetPercDeviation(val) {
      if(this.item.sales_line) {
        if(val > 0 && val <= 10000) {
          return this.item.sales_line.deviation_range_1
        } else if(val > 10000 && val <= 20000) {
          return this.item.sales_line.deviation_range_2
        } else if(val > 20000) {
          return this.item.sales_line.deviation_range_3
        }
      }
      return null
    },
    getPlanDataTurnoverActual() {
      if(this.planData && (this.item.status === 'Draft' || this.item.status === 'Feedback')) {
        if(this.planData.turnover_actual !== null) {
          var planBaseline= this.calculatePriceBasedonDuration(parseInt(this.planData.turnover_actual))
          this.item.plan_outlook = planBaseline
          return planBaseline
        }
      }else if(this.item.plan_outlook !== null && this.item.plan_outlook !== '') {
        return this.calculatePriceBasedonDuration(parseInt(this.item.plan_outlook))
      }
      return null
    },
    checkBudgetUsedup() {
      this.saveDisabled = false
      if(this.item.contract_year && this.item.type && (this.item.status === 'Draft' || this.item.status === 'Feedback')) {
        let url = '/api/getBudgetUsedUp?type='+this.item.type+'&year='+this.item.contract_year
        axios
          .get(url)
          .then((response) => {
            var planData = response.data.planData
            if(planData.rowCount > 0) {
              var contractData = response.data.contractData
              var budgetTolerance = response.data.budgetTolerance

              var sumTargetInvest = planData.sumTargetInvest ?? 0
              var sumTargetDiscount = planData.sumTargetDiscount ?? 0
              var sumPlanInvest = parseInt(sumTargetInvest) +  parseInt(sumTargetDiscount) + parseInt(budgetTolerance)

              var sumContractInvest = contractData.sumContractInvest ?? 0
              var sumContractDiscount = contractData.sumContractDiscount ?? 0
              var sumTotalnvest = parseInt(sumContractInvest) +  parseInt(sumContractDiscount)

              // Sum of marketing activities & discount
              var discount = this.item.discount ?? 0
              var marketingActivities = this.item.marketing_activities_maximum ?? 0
              var dbInvest = parseInt(discount) +  parseInt(marketingActivities)
              var sumTotalnvest = sumTotalnvest + dbInvest

              if(sumPlanInvest <= sumTotalnvest) {
                this.saveDisabled = true
              }
            }
        })
      }
    },
    checkRequiredInBiosApoItem() {
      const self = this
      const requiredInItems = []
      self.reqBiosApoItems = []

      if (self.item.type !== 'BIOS_APO' || !self.item.addresses) {
        return false
      }

      const periods = ['yearly', 'q1', 'q2', 'q3', 'q4']
      function processLine(line, addressId, isChild = false) {
        if (line.type === 'marketing_activity' && line.required_in_bios_apo_item) {
          const key = `${addressId}-${line.product.id}`

          const hasEditablePeriod = periods.some(p =>
            self.$refs.contractItem && !self.$refs.contractItem.isReadonly(line, p, isChild)
          )
          if (line.delivery && hasEditablePeriod) {
            requiredInItems.push(key)
          }

          const hasValidQuantity = periods.some(p =>
            self.$refs.contractItem && !self.$refs.contractItem.isReadonly(line, p, isChild) &&
            line.delivery?.[p]?.quantity > 0
          )
          if (!hasValidQuantity) {
            self.reqBiosApoItems.push(key)
          }
        }

        if (line.children && Array.isArray(line.children) && line.children.length) {
          line.children.forEach(child => processLine(child, addressId, true))
        }
      }

      self.item.addresses.forEach(address => {
        if (address.address_type !== 'delivery') return
        address.items.forEach(line => processLine(line, address.id, false))
      })

      return (
        requiredInItems.length > 0 &&
        self.reqBiosApoItems.length === requiredInItems.length
      )
    },
    duplicateContractCheck() {
      this.duplicateContract = false
      const {item, user} = this
      if (item?.contract_year && item?.customer_external_id && ['APO','BIOS_APO'].includes(item?.type) && !user?.is_super_user) {
        axios.post('/api/sandoz/ice-peak/contracts/check-duplicate-contract', {
          customer_external_id: item.customer_external_id,
          contract_year: item.contract_year,
          contract_id: item.id,
        })
          .then(({data}) => {
            this.duplicateContract = data.is_duplicate
          })
          .catch(error => {
            console.error("Error checking duplicate contract:", error)
          });
      }
    },
    compareTurnoverExpectationForOTC() {
      if(this.apoOtcContract) {
        var plan_turnover_expectation = this.item.plan_turnover_expectation ? parseInt(this.item.plan_turnover_expectation) : 0
        var turnover_expectation = this.item.turnover_expectation ? parseInt(this.item.turnover_expectation) : 0
        if((plan_turnover_expectation !== 0 && plan_turnover_expectation !== null && turnover_expectation !== 0 && turnover_expectation !== null) && plan_turnover_expectation !== turnover_expectation){
          return true
        }     
      }
      return false
    },
    compareMarketingActivityForOTC() {
      if(this.apoOtcContract) {
        var plan_target_invest = this.item.plan_target_invest ? parseInt(this.item.plan_target_invest) : 0
        var marketing_activities_otc = this.item.marketing_activities_otc ? parseInt(this.item.marketing_activities_otc) :0
        if((plan_target_invest !== 0 && plan_target_invest !== null && marketing_activities_otc !== 0 && marketing_activities_otc !== null) && plan_target_invest !== marketing_activities_otc){
          return true
        }     
      }
      return false
    },
    updateMarketingActivitiesMaximumOTC() {

      if(this.apoOtcContract) {
        const deliveryAddress = (this.item?.addresses || []).filter(
          item => item.address_type === 'delivery'
        )

        const results = (deliveryAddress || [])
        .flatMap(address => address.items || [])
        .filter(item => item.product?.product_master?.apo_otc_sortalys_product === true)

        const totals = results.reduce(
          (acc, item) => {
            acc.totalQuantity += Number(item.delivery.yearly.quantity || 0)
            acc.totalPrice += Number(item.price || 0)
            return acc
          },
          { totalQuantity: 0, totalPrice: 0 }
        )

        this.sortalysQuantity = totals.totalQuantity
        this.sortalysPrice = totals.totalPrice
        this.item.marketing_activities_maximum = this.item.marketing_activities_otc + this.sortalysPrice
      }
    }
  }
}
</script>

<style scoped>
.invest-accordion svg:focus {
  outline: none;
}

::v-deep(td.exist_error) {
  border: 1px solid red;
}

.pdfFiles {
  padding-left: 0;
  font-size: 120%;
  margin-top: 10px;
  text-transform: uppercase;
  font-weight: bold;
  border-bottom: none !important;
}

.pdfFiles .show-deleted-checkbox {
  font-size: 90% !important;
  text-transform: lowercase;
  font-weight: normal;
}

.bg-disable {
  background: lightgrey;
}

label.has-error {
  color: #dc3545
}
</style>


